import { getCookie, simulateAsyncOperation, throttle } from 'mmbclient/Common/CommonFunctions';
import { calculateFriegthAmount, calculateFuelAmt, friegthAmount, getClientCommissionDetails } from 'mmbclient/Common/CommonMethods';
import { getClientAddressFromDb, loadDoketChargedBySeries, loadRateFromDb, loadRatesFromDBForLogistic } from 'mmbclient/Common/CommonMMBLIVEService';
import { getClientBalance } from 'mmbclient/Common/CommonRazorPay';
import { checkSession, getAllCityDataFromDb, getAllClients, getAllCountryDataFromDb, getAllPincodeFromDb, getAllStateDataFromDb, getBranchFromDb, getClientAllDetail, getClientDetail, getClientSeriesRateFromDb, getClientVasViewDataFromDb, getClientViewDataFromDb, getConsigneeDetails, getConsignorDetails, getCountryDetails, getNetworkDataFromDb, getNetworkDetails, getPincodeDetails, getServiceAssociatMMBDataFromDb, getServiceDataFromDb, getServiceDetails, getTatDaysFromDb, getTaxSeriesFromDb, loadAllMasterData } from 'mmbclient/Common/CommonService';
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, EP, EWAY_BILL, FAST_BOOKING_DOCKETJASPER, FAST_BOOKING_REQUEST_PATH, GLOBAL_CONTEXT, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, MASTERdATA, MMB, MMB_LIVE, PAGE_LOADING_TIME, US, USER_TYPE_COOKIE_NAME, WALLET, WEIGTH_DIMENSION } from 'mmbclient/Common/CommonVariable';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { preconnect } from 'react-dom';
import { toast } from 'react-toastify';


function FastBookingController() {

    const store = useContext(GLOBAL_CONTEXT);
    const wallet = useContext(WALLET);

    //pincode validation state 
    const [isValidating, setIsValidating] = useState(false);


    //masterdata gloabl
    const masterData = useContext(MASTERdATA);

    // toggle state for weigth modal
    const [showDimensionWeigthModal, setShowDimensionWeigthModal] = useState(false);
    // toggle state for ewaybill modal
    const [showEWayBillModal, setShowEWayBillModal] = useState(false);
    // loading state
    const [loading,setLoading] = useState(false);
    
    const [originPin,setOriginPin] = useState('');
    const [disableAwb,setDisableAwb] = useState(false);
    const [modifyingData,setModifyingData] = useState({});
    
    
    const [date,setDate] = useState(new Date())
    const [isModifyingDisable,setIsModifyingDisable] = useState(false);
    const [isSaveDisable,setIsSaveDisable] = useState(true);
    const [dimensionList,setDimensionList] = useState([]);
    const [eWayBillList,setEWayBillLIst] = useState([]);

   // for only pincode
    const [pincodeList, setPincodeList] = useState([]);

    //filterring state variable
    const [filteredOriginPincodes,setFilteredOriginPincodes] = useState([]);
    const [filteredDestPincodes,setFilteredDestPincodes] = useState([]);
    const [activeOriginIndex,setActiveOriginIndex] = useState(-1);
    const [activeDestIndex,setActiveDestIndex] = useState(-1)

    // load data store state
    const [client, setClient] = useState('');
    const [isSameAwb,setIsSameAwb] = useState('');
    // client state for combobox
    const [clientOption, setClientOption] = useState([]);

    //service state that is going to load in combobox 
    const [service,setService] = useState(["Select..."])

    //network state for combobox of network
    const [network,setNetwork] = useState(["Select..."])

    //country state data
    const [country,setCountry] = useState([]);

    const dateRef = useRef(null);
    //state 
    const [state,setState] = useState([]);

    // city state
    const [city,setCity] = useState([]);

    // consignee filtering
    const [consigneeList,setConsigneeList] = useState([]);
    const [filterConsignee,setFilterConsignee] = useState([]);
    const [activeConsigneeIndex,setActiveConsigneeIndex] = useState(-1);

    const [fuelAmount,setFuelAmount] = useState(0);

    const SELECT = "Select..."

    const [printDocket,setPrintDocket] = useState(false);
    const [docketSeriesRate,setDocketSeriesRate] = useState([]);

    const [formValues, setFormValues] = useState({
        awbNo:'',
        forwardingNo:'',
        date:date,
        tatDate:date,
        client:'',
        subClient:'',
        network:SELECT,
        service:SELECT,
        originPincode:'',
        originCity:'',
        originCityCode:'',
        originStateCode:'',
        destPincode:'',
        destCity:'',
        destCityCode:'',
        lbZone:'',
        stateCode:'',
        docType:'dox',
        pcs:'',
        actualWt:'',
        volumneWt:'',
        billingWt:'',
        insInvoiceNo:'',
        insValue:'',
        insurance_type:'NA',
        insAmount:0,
        insRate:0,
        paymentType:'Credit',
        amount:'',
        friegthAmt:0,
        codValue:'',
        codAmount:'',
        fodValue:'',
        fodAmount:'',
        ewayBill:'',
        content:'',
        remarks:'',
        consignee:'',
        WEIGHT_SLAB:'',
        WEIGHT_TYPE:'',
        rate_format:'',
        docketCharge:0,
        fuelAmt:0,
        fuelRate:0,
        taxName1:'',
        taxRate1:0,
        service_tax:0,
        taxName2:'',
        taxRate2:0,
        edu_cess:0,
        taxName3:'',
        taxRate3:0,
        h_edu_Cess:0,
        totalGst:0,
        Total:0,
        clientCode:getCookie(USER_TYPE_COOKIE_NAME) === US ? getCookie(LOGIN_COOKIE_NAME).split(LOGIN_COOKIE_NAME_SPLITBY)[1] : '',
        userType: getCookie(APP_TYPE_COOKIE_NAME)
    })

    const [list_client,setList_client] = useState([]);
    const [list_clientRate,setList_clientRate] = useState([]);
    const [list_loadRateForAutoCalculation,setList_loadRateForAutoCalculation] = useState([]);

    const [weigthDimension,setWeigthDimension]  = useState({
        heigth:'',
        width:'',
        length:'',
        actwt:'',
        pcs:'',
        volwt:''
    });

    const [ewaybillObj,setEWayBillObj] = useState({
        'awb_no':'',
        'ewayBill':'',
        'invNo':'',
        'invDate':'',
        'invValue':'',
        'validity':'',
        'ewaybillapi':false
    })

    useEffect(()=>{
        const fetchData=async()=>{
            setLoading(true);
            try {
                // console.log("====================================",masterData.LIST_CLIENT);
                // console.log(masterData.isClientLoaded)
                // if(!masterData.isClientLoaded){
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                        loadAllServices(store),
                        loadAllNetwork(store),
                        loadAllPincode(store),
                        loadClientAllDetail(store),
                        loadClientVasAllDetail(store),
                        // loadCountryDetails(store),
                        // loadStateData(store),
                        // loadCityData(store)
                        // loadAllMasterData(store),
                    ]);
                    setTimeout(()=>{
                        masterData.setIsClientLoaded(true)
                    },0)
                    // console.log("what", masterData.isClientLoaded);
                // }else{
                    
                //     console.log("not calling;")
                // }
                await loadAllConsignee(store);
                setAllData(masterData);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    },[]);

    // useEffect(() => {
    // console.log("form: " , formValues);
    // }, [formValues]);

    const setAllData=(masterData)=>{
        let lst_Client = [];
        if (masterData.LIST_CLIENT.length > 0) {
            let i;
            for (i of masterData.LIST_CLIENT) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
            setClientOption(lst_Client);
            setFormValues(prev=>({
                ...prev,
                'client':lst_Client[0]
            }))
            
        }

        if(masterData.LIST_NETWORK.length>0){
            let lst_network=[];
            for(let i of masterData.LIST_NETWORK){
                lst_network.push(i.net_name + " | " + i.net_code)
            }
            setFormValues(prev=>({
                ...prev,
                'network':lst_network[0]
            }))
            setNetwork(lst_network);
        }

        if (masterData.LIST_SERVICE.length > 0) {
            let lst_service = []
            let i;
            for (i of masterData.LIST_SERVICE) {
                    lst_service.push(i.ser_name+" | "  + i.ser_code);
            }
            setFormValues(prev=>({
                ...prev,
                'service':lst_service[0]
            }))
            setService(lst_service);
        }

        if(masterData.LIST_PINCODE.length>0){
            const pincode = masterData.LIST_PINCODE.map(i => i.pin_code);

            setPincodeList(pincode);
        }
        
    }


    const loggerFunc = () => {
        checkSession(store);
        getClientBalance(wallet);
    }
    
    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    async function loadClientAllDetail(store) {
        // console.log("client response ",masterData.LIST_CLIENT);
        if(masterData.LIST_CLIENT.length>0){
            console.log("returning from loadClientAllDetail");
            return;
        }

        const response = await getClientViewDataFromDb();
        let lst_Client = [];
        if (response.length > 0) {
            let i;
            for (i of response) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
            setClientOption(lst_Client);
            setFormValues(prev=>({
                ...prev,
                'client':lst_Client[0]
            }))
            console.log(response);
            setList_client(response);
            masterData.setLIST_CLIENT(response);
            
        }
    }

    async function loadClientVasAllDetail(store) {
        if(masterData.LIST_CLIENTVAS.length>0) return;
        const response = await getClientVasViewDataFromDb();
        if (response.length > 0) {
            masterData.setLIST_CLIENTVAS(response);
        }
        console.log("all client vas detail", response);
    }

    // loan network from server
    async function loadAllNetwork(store){
        if(masterData.LIST_NETWORK.length>0) return;
        const response = await getNetworkDataFromDb();
        let lst_network = [];
        let i;
        lst_network.push("Select...")
        if(response.length>0){
            
            for(i of response){
                lst_network.push(i.net_name + " | " + i.net_code)
            }
            // console.log("network all detail", response);
            setFormValues(prev=>({
                ...prev,
                'network':lst_network[0]
            }))
            masterData.setLIST_NETWORK(response);
            setNetwork(lst_network);
        }
    }

    // load service from server
    async function loadAllServices(store) {
        if(masterData.LIST_SERVICE.length>0) return;
        const response = await getServiceDataFromDb();
        if (response.length > 0) {
            let lst_service = []
            let i;
            lst_service.push('Select...');
            for (i of response) {
                    lst_service.push(i.ser_name+" | "  + i.ser_code);
            }
            console.log("all service", response)
            setFormValues(prev=>({
                ...prev,
                'service':lst_service[0]
            }))
            masterData.setLIST_SERVICE(response)
            setService(lst_service);
        }
    }

    // load consignee from server
    async function loadAllConsignee(store){
        const response = await getConsigneeDetails(store);
        let lst_consignee = [];
        if(response.length>0){
            for(const i of response){
                lst_consignee.push(i.name+" | " + i.address+" | " +  i.contact_no)
            }
        }
        setConsigneeList(lst_consignee);
    }

    // load pincode from server
    async function loadAllPincode() {
        if(masterData.LIST_PINCODE.length>0) return;
        const response = await getAllPincodeFromDb();

        if (!response || response.length === 0) return;

        const pincode = response.map(i => i.pin_code);

        setPincodeList(pincode);
        masterData.setLIST_PINCODE(response);
        console.log(response);
    }

    
    // load country detail
    async function loadCountryDetails(store) {
        if(masterData.LIST_COUNTRY.length>0) return;
        const response = await getAllCountryDataFromDb();
        if (response.length > 0) {
            const country = [];
            let i;
            for (i of response) {
                country.push(i.country_code.toUpperCase() + " | " + i.country_name);
            }
            masterData.setLIST_COUNTRY(response);
            setCountry(country);
        }
    }

    // all state
    async function loadStateData(store) {
        if(masterData.LIST_STATE.length>0)return;
        const response = await getAllStateDataFromDb();
        if(response.lenght>0){
            const lst_state = [];
            let i;
            for(i of response){
                lst_state.push(i.state_code)
            }
            setState(lst_state);
            masterData.setLIST_STATE(response);
        }
    }

    //city
    async function loadCityData(store) {
        if(masterData.LIST_CITY.length>0)return;
        const response = await getAllCityDataFromDb();
        if(response.lenght>0){
            const lst_city = [];
            let i;
            for(i of response){
                lst_city.push(i.city_name+" | " + i.city_code)
            }
            setCity(lst_city);
            masterData.setLIST_CITY(response);
        }
    }

    async function loadTatDays() {
        if(masterData.LIST_TATDAYS.length>0)return;
        const response = await getTatDaysFromDb();
        if(response.length>0){
            masterData.setLIST_TATDAYS(response);
        }
    }

    //filter origin pincode
    const filterOriginPincodes = (value) => {
        if (!value.trim()) {
            setFilteredOriginPincodes([]);
            return;
        }
        // const onlyPins = pincodeList.map(item => item.split('|')[0]);
        const filtered = pincodeList.filter(pin =>
            pin.startsWith(value)
        );
        setFilteredOriginPincodes(filtered);
    };

    // filtering dest pincode
    const filterDestPincodes = (value) => {
        if (!value.trim()) {
            setFilteredDestPincodes([]);
            return;
        }
        // const onlyPins = pincodeList.map(item => item.split('|')[0]);
        const filtered = pincodeList.filter(pin =>
            pin.startsWith(value)
        );
        setFilteredDestPincodes(filtered);
    };

    const filterConsigneefunc=(value)=>{
        if(!value.trim()){
            setFilterConsignee([]);
            return;
        }
        // const consignee = consigneeList.map(item=>item.split('|')[0].trim());
        const filtered = consigneeList.filter(item=>
            item.trim().toLowerCase().startsWith(value.trim().toLowerCase())
        )
        setFilterConsignee(filtered);
    }
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }

    const debouncedFilterOrigin = useMemo(() => debounce(filterOriginPincodes, 300), [pincodeList]);
    const debouncedFilterDest = useMemo(() => debounce(filterDestPincodes, 300), [pincodeList]);
    const debouncedFilterConsignee = useMemo(() => debounce(filterConsigneefunc, 300), [consigneeList]);
    

    // handle input regex
    const handleInputChange= async(event)=>{
        const { name, type, checked, value } = event.target;

        if (name === 'awbNo') {
            if (value === '' ||
                (value.length <= 25 && /^[a-zA-Z0-9]*$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value.toUpperCase()
                }));
            }
        } 
        else if (name === 'forwardingNo') {
            if (value === '' ||
                (value.length <= 25 && /^[a-zA-Z0-9]*$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value.toUpperCase()
                }));
            }
        }
        else if(name==="originPincode"){
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value
                }));
                debouncedFilterOrigin(value);
            }
        }
        else if (name === 'destPincode') {
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues(prev=>({
                    ...prev,
                    [name]: value
                }));
                debouncedFilterDest(value);
            }
        }
        else if(name==='client'){
            setFormValues(prev=>({
                ...prev,
                [name] : value
            }))
        }else if(name==='consignee'){
            setFormValues(prev=>({
                ...prev,
                [name]:value
            }))
            debouncedFilterConsignee(value);
        }else if(name==='ewaybillapi'){
            setEWayBillObj(prev => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
            // console.log(value,name,checked);
        }
        else if(name==='printDocket'){
            setPrintDocket(type === "checkbox" ? checked : value);
            // console.log(value,name,checked);
        }
        else{
            setFormValues(prev=>({
                ...prev,
                [name]:value
            }))
        }
    }

    const handleDecimalInputChange=(event)=>{
        const {name,value} = event.target
        if (/^\d*\.?\d{0,3}$/.test(value)) {
            setFormValues(prev => ({
                ...prev,
                [name]: value
            }));
        }
    }

    const handleBlurOfVolumeWt=()=>{
        const actual = Number(formValues.actualWt);
        const volume = Number(formValues.volumneWt);

        const billingWeight = actual > volume ? actual : volume;
        setFormValues(prev=>({
            ...prev,
            'billingWt':billingWeight
        }))
    }

    const handleWeigthDecimalInputChange=(event)=>{
        const {name,value} = event.target
            if (/^\d*\.?\d*$/.test(value)) {
                setWeigthDimension(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
    }

    const handleNumberInputChange=(event)=>{
        const {name,value} = event.target
        if(name==='ewayBill' && /^\d*$/.test(value)){
            setEWayBillObj(prev=>({
                ...prev,
                [name]:value
            }))
        }
        else if (/^\d*$/.test(value)) {
            setFormValues(prev => ({
                ...prev,
                [name]: value
            }));
        }
    }

    const handleBlurPincode =async (type) => {
        try {
            setLoading(true);
            if ("originPincode" === type) {
                setFormValues({
                    ...formValues,
                    'originCity': '',
                    'originCityCode':'',
                    'or':''
                });
                const name = 'originCity';
                if (formValues.originPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                for (const currentValue of masterData.LIST_PINCODE) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_name;
                    const cityCode = currentValue.city_code;
                    const stateCode = currentValue.state_code;
                    // const countryCode = currentValue.country_code;
                    if (pincode === formValues.originPincode) {
                        setFormValues({
                            ...formValues,
                            [name]: cityName,
                            'originPincode':pincode,
                            'originCityCode':cityCode,
                            'originStateCode':stateCode
                        });
                        setLoading(false);
                        return;
                    }
                }
            } else if ("destPincode" === type) {
                setFormValues({
                    ...formValues,
                    'destCity': '',
                    'destCityCode': '',
                    'destStateCode': '',
                });
                const name = 'destCity';
                if (formValues.destPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                for (const currentValue of masterData.LIST_PINCODE) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_name;
                    const cityCode = currentValue.city_code;
                    const stateCode = currentValue.state_code;
                    // const countryCode = currentValue.country_code;
                    if (pincode === formValues.destPincode) {
                        setFormValues({
                            ...formValues,
                            [name]: cityName,
                            'destPincode': pincode,
                            'destCityCode': cityCode
                        });
                        setLoading(false);
                        return;
                    }
                }
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };



    const selectOriginPincode=async(value)=>{
        for(const i of masterData.LIST_PINCODE){
            if (value === i.pin_code) {
                setFormValues(prev=>({
                    ...prev,
                    "originPincode": i.pin_code,
                    "originCity": i.city_name,
                    "originCityCode":i.city_code
                }
                ));
                break;
            }
        }
    await loadTatDays();    
    setFilteredOriginPincodes([]);
    }


    const selectDestPincode = (item) => {
    for (const i of masterData.LIST_PINCODE) {
        if (i.pin_code === item) {
            setFormValues(prev=>({
                ...prev,
                'destPincode': i.pin_code,
                'destCity': i.city_name,
                'stateCode':i.state_code,
                'destCityCode':i.city_code,
                'lbZone':i.zon_code
            }));
            setTateDate(i.zon_code)
            break;
        }
    }
    setFilteredDestPincodes([]);
    };

    const setTateDate=(zonecode)=>{
        if(formValues.service==='Select...')return;
        let days = 1;
        const service = formValues.service.split("|")[1].trim();
        const serviceGroupCode = getServiceGroupCode(service);
        for(let tat of masterData.LIST_TATDAYS){
            if (tat.zone_code===zonecode && tat.service_code===serviceGroupCode) {
                days = tat.tat_days;
                break;
            }
        }

            // add days to date
        const newDate = new Date(formValues.date);
        newDate.setDate(newDate.getDate() + days);
        setFormValues(prev=>({
            ...prev,
            'tatDate':newDate
        }))
    }

    const selectConsignee=(item)=>{
        for(const consignee of consigneeList){
            if(item.trim()===consignee.trim()){
                setFormValues(prev=>({
                ...prev,
                'consignee':consignee.trim()
                }))
            }
            setFilterConsignee([]);
        }
    }

    const awbBlurHandle=async(e)=>{
        if(formValues.awbNo===''){
            callToastWarnAlert("Enter awb Number",2000);
            requestFocusOnInvalid(e,'awbNo')
            return;
        } 
        if(isSameAwb===formValues.awbNo)return;
        try{

            setLoading(true);
            checkSession(store);
            if (!getCookie(LOGIN_SESSION_NAME)) {
                return;
            }
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let column=''
            let condition = ''
            let tableBean = ''
            if (c.length === 4) {

                if(cookieUserType==='MMB_LIVE'){
                    column = "db.awb_no,db.fr_code,db.branch_code,db.client_mode,db.booking_type,db.invoice_no,db.booking_date,db.tat_date,db.forwarding_no,db.client_code,db.sub_client_code,db.origin_city,"
                    + "db.origin_pincode,db.pincode,db.destination_city,db.network_code,db.service_code,db.payment_type,"
                    + "db.document_type,db.packets,db.volume_weight,db.actual_weight,db.hidden_charges_ttl,db.billing_weight,db.freight_amount,db.fuel_amount,"
                    + "db.total,db.remarks,db.content,db.tax_id,db.tax_amount1,db.tax_amount2,db.tax_amount3,CONCAT(IFNULL(cnee.consignee_name,''),' ',IFNULL(cnee.consignee_address,db.consignee_phone),' ',IFNULL(cnee.consignee_phone,'')) as consignee_phone,CONCAT(IFNULL(cnsr.consignor_name,''),' ',IFNULL(cnsr.consignor_address,db.consignor_phone),' ',IFNULL(cnsr.consignor_phone,'')) as consignor_phone,"
                    + "db.fwd_weight,fwd_insurance,db.fwd_city,db.fwd_amount,db.shipper_cost,db.commission,db.fwd_fuel,db.fwd_gst,db.sale_rate,db.travel_status,"
                    + "db.entry_type,db.special_entry,db.do_in,IFNULL(dbv.awb_no,'NA') as vas_awb_no,IFNULL(dbv.insurance_invoice_no,'NA') as insurance_invoice_no,"
                    + "IFNULL(dbv.ewaybill_no,'NA') as ewaybill_no,IFNULL(dbv.collect_amount,0) as collect_amount,"
                    + "IFNULL(dbv.insurance_type,'NA') as insurance_type,IFNULL(dbv.insurance_rate,0) as insurance_rate,IFNULL(dbv.insurance_value,0) as insurance_value,"
                    + "IFNULL(dbv.insurance_amount,0) as insurance_amount,IFNULL(dbv.cod_value,0) as cod_value,IFNULL(dbv.cod_amount,0) as cod_amount ,"
                    + "IFNULL(dbv.fod_value,0) as fod_value,IFNULL(dbv.fod_amount,0) as fod_amount,IFNULL(dbv.docket_charge,0) as docket_charge,"
                    + "IFNULL(dbv.other_vas_detail,'NA') as other_vas_detail,IFNULL(dbv.other_total_amount,0) as other_total_amount,"
                    + "IFNULL(dbv.dimension_detail,'NA') as dimension_detail,IFNULL(dbv.oda_amount,0) as oda_amount,IFNULL(dbv.opa_amount,0) as opa_amount ";

                    tableBean = "DataEntryBean";
                    if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                        condition = "where db.awb_no='" + formValues.awbNo + "'";
                    }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                        condition = "where db.awb_no='" + formValues.awbNo + "'";
                    }
                }else if(cookieUserType==='MMB'){
                    return;
                    // column = "cb.awb_no AS 'awb_no',cb.fwd_no As forwarding_no,cb.branch_cd as branch_code,cb.client_cd as client_code,cb.sub_client_cd as sub_client_code,cb.boking_dt AS 'booking_date',cb.tat_date As tat_date, cb.network As 'network_code', "
                    // + "cb.service As service_code,cb.pkgs AS packets,cb.type AS document_type,cb.vol_wt as volume_weight, cb.act_wt AS actual_weight,cb.bil_wt as billing_weight,cb.amount As freight_amount,cb.insur_type as insurance_type,"
                    // + "cb.insur_value as insurance_value, cb.insur_rate as insurance_rate, cb.insur_amt as insurance_amount, cb.cod_amt as cod_amount,cb.fod_amt as fod_amount,cb.cwc_amt,cb.fuel as fuel_amount,cb.special as special_entry,"
                    // + "cb.origin_pincode as origin_pincode,cb.content as content,cb.pincode as pincode,cb.insur_invoice as insurance_invoice_no, cb.recv_ph as consignee_phone,cb.weight_slab,cb.comments as remarks";
                    // tableBean = "DataEntryBean";
                    // if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                    //     condition = "where cb.awb_no='" + formValues.awbNo + "'";
                    // }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                    //     condition = "where cb.awb_no='" + formValues.awbNo + "'";
                    // }
                }

                let query = { "userKey": c[0], 'column':column,'value':condition,'beanname':tableBean};
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query),
                        key:"checkService",
                        userType:cookieUserType
                    })
                };
                const path = API_PATH + FAST_BOOKING_REQUEST_PATH + "getdataviaawbno";
                const res = await fetch(path, requestOptions);
                const data = await res.json();

                const response = data[0][tableBean];
                if(response!=="Result Not Found"){
                    const detailValues = response[0];
                    const max = new Date();
                    max.setHours(0,0,0,0);

                    const min = new Date();
                    min.setDate(min.getDate() - 1);
                    min.setHours(0,0,0,0);

                    const checkDate = new Date(detailValues.booking_date);
                    checkDate.setHours(0,0,0,0);

                    if(cookieUserType===MMB_LIVE){
                        if (checkDate >= min && checkDate <= max) {
                            setModifyAwbValuesMMB_LIVE(detailValues);
                        } else {
                            setIsModifyingDisable(true);
                            setIsSaveDisable(true)
                            setUnModifyAwbValuesMMB_LIVE(detailValues);
                        }
                    }
                }else{
                    setIsSameAwb(formValues.awbNo);
                }
            }
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    const [modifying,setModifying] = useState(false);

    const setModifyingAwbValuesMMB=(data)=>{
        const clientCode = data.client_code;
        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === clientCode
        );

        if(selectedClient===undefined){
            alert(`${data.awb_no} already booked by another customer.`)
            resetAction();
            return;
        }

        const confirmation = window.confirm("Do you want to modify?\nAwb No. " + formValues.awbNo);
        if(confirmation){
            setModifying(true);
            // console.log(data)
        }else{
            resetAction();
            return;
        }

        setModifyingData(data);
        setDisableAwb(true);
        selectOriginPincode(data.origin_pincode);
        selectDestPincode(data.pincode);
        const serviceCode = data.service_code;
        const networkCode = data.network_code;
        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === serviceCode
        );
        const selectNetwork = masterData.LIST_NETWORK.find(
            n=> n.net_code=== networkCode
        )
        // console.log("netwr",selectNetwork)
        setClient(selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase())
        setFormValues(prev=>({
            ...prev,
            'awbNo': data.awb_no,
            'forwardingNo': data.forwarding_no,
            'date': data.booking_date,
            'tatDate':data.tat_date,
            'subClient': data.sub_client_code,
            'docType': data.document_type==='D'?'dox':'non-dox',
            'pcs': data.packets,
            'actualWt': data.actual_weight,
            'volumneWt': data.volume_weight,
            'billingWt': data.billing_weight,
            'insInvoiceNo':data.insurance_invoice_no,
            'insValue':data. insurance_value,
            'paymentType':'Credit',
            'friegthAmt':data.freight_amount,
            'amount': data.freight_amount,
            'codAmount': 0,
            'codValue': data.cod_amount,
            'fodAmount': 0,
            'fodValue': data.fod_amount,
            'ewayBill': '',
            'content': data.content,
            'remarks': data.remarks,
            'consignee': data.consignee_phone?data.consignee_phone.trim():'',
            'service': selectedService.ser_name+" | "  + selectedService.ser_code,
            'network': selectNetwork.net_name + " | " + selectNetwork.net_code,
            'client': selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase()
        }))
    }

    const setModifyAwbValuesMMB_LIVE=(data)=>{

        const clientCode = data.client_code;
        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === clientCode
        );

        if(selectedClient===undefined){
            alert(`${data.awb_no} already booked by another customer.`)
            resetAction();
            return;
        }

        const confirmation = window.confirm("Do you want to modify?\nAwb No. " + formValues.awbNo);
        if(confirmation){
            setModifying(true);
            setIsSaveDisable(true);
        }else{
            resetAction();
            return;
        }

        setModifyingData(data);
        setDisableAwb(true);
        selectOriginPincode(data.origin_pincode);
        selectDestPincode(data.pincode);
        
        const serviceCode = data.service_code;
        const networkCode = data.network_code;
        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === serviceCode
        );

        // console.log("service",selectedService)
        let insuranceValue = 'NA'
        if(data.insurance_type==='OW'){
            insuranceValue = 'Owner'
        }else if(data.insurance_type==='CA'){
            insuranceValue = 'Carrier'
        }
        const selectNetwork = masterData.LIST_NETWORK.find(
            n=> n.net_code=== networkCode
        )
        let gstTotal = Number(data.tax_amount1||0) + Number(data.tax_amount2||0) + Number(data.tax_amount3||0)
        console.log(gstTotal)
        console.log(data.total);
        console.log(data.fuel_amount)
        // console.log("netwr",selectNetwork)
        setClient(selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase())
        
        setFormValues(prev=>({
            ...prev,
            'awbNo': data.awb_no,
            'forwardingNo': data.forwarding_no,
            'date': data.booking_date,
            'tatDate':data.tat_date,
            'subClient': data.sub_client_code,
            'docType': data.document_type==='D'?'dox':'non-dox',
            'pcs': data.packets,
            'actualWt': String(data.actual_weight),
            'volumneWt': String(data.volume_weight),
            'billingWt': String(data.billing_weight),
            'insInvoiceNo':data.insurance_invoice_no,
            'paymentType':data.payment_type,
            'friegthAmt':data.freight_amount,
            'amount': data.freight_amount,
            'codAmount': data.cod_amount,
            'codValue': data.cod_value,
            'fodAmount': data.fod_amount,
            'fodValue': data.fod_value,
            'ewayBill': data.ewaybill_no,
            'content': data.content,
            'remarks': data.remarks,
            'insurance_type':insuranceValue,
            'insRate':data.insurance_rate,
            'insAmount':data.insurance_amount,
            'insValue':data.insurance_value,
            'docketCharge':data.docket_charge,
            
            'consignee': data.consignee_phone.trim(),
            'service': selectedService.ser_name+" | "  + selectedService.ser_code,
            'network': selectNetwork.net_name + " | " + selectNetwork.net_code,
            'client': selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase()
        }))

        setTimeout(()=>{
            setFormValues(prev=>({
            ...prev,
            'totalGst': gstTotal,
            'Total':data.total,
            'fuelAmt':data.fuel_amount,
        }))
        },300)
    }

    const setUnModifyingAwbValuesMMB=(data)=>{
        const clientCode = data.client_code;
        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === clientCode
        );

        if(selectedClient===undefined){
            alert(`${data.awb_no} already booked by another customer.`)
            resetAction();
            return;
        }else{
            alert("Awb No. already exist.");
        }

        setModifyingData(data);
        setDisableAwb(true);
        selectOriginPincode(data.origin_pincode);
        selectDestPincode(data.pincode);
        
        const serviceCode = data.service_code;
        const networkCode = data.network_code;
        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === serviceCode
        );

        const selectNetwork = masterData.LIST_NETWORK.find(
            n=> n.net_code=== networkCode
        )

        // const selectedClient = clientDetail.find(
        //     c => c.client_code === clientCode
        // );
        setClient(selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase())
        setFormValues(prev=>({
            ...prev,
            'awbNo': data.awb_no,
            'forwardingNo': data.forwarding_no,
            'date': data.booking_date,
            'subClient': data.sub_client_code,
            'tatDate':data.tat_date,
            'docType': data.document_type==='D'?'dox':'non-dox',
            'pcs': data.packets,
            'actualWt': data.actual_weight,
            'volumneWt': data.volume_weight,
            'billingWt': data.billing_weight,
            'insInvoiceNo':data.insurance_invoice_no,
            'insValue':data. insurance_value,
            'friegthAmt':data.freight_amount,
            'paymentType':"Credit",
            'amount': data.freight_amount,
            'codAmount': 0,
            'codValue': data.cod_amount,
            'fodAmount': 0,
            'fodValue': data.fod_amount,
            'ewayBill': '',
            'content': data.content,
            'remarks': data.remarks,
            'consignee': data.consignee_phone?data.consignee_phone.trim():'',
            'service': selectedService.ser_name+" | "  + selectedService.ser_code,
            'network': selectNetwork.net_name + " | " + selectNetwork.net_code,
            'client': selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase()
        }))
    }

    const setUnModifyAwbValuesMMB_LIVE=(data)=>{

        const clientCode = data.client_code;
        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === clientCode
        );

        if(selectedClient===undefined){
            alert(`${data.awb_no} already booked by another customer.`)
            resetAction();
            return;
        }else{
            alert("Awb No. already exist.");
        }

        setModifyingData(data);
        setDisableAwb(true);
        selectOriginPincode(data.origin_pincode);
        selectDestPincode(data.pincode);
        
        const serviceCode = data.service_code;
        const networkCode = data.network_code;
        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === serviceCode
        );

        const selectNetwork = masterData.LIST_NETWORK.find(
            n=> n.net_code=== networkCode
        )

        let insuranceValue = 'NA'
        if(data.insurance_type==='OW'){
            insuranceValue = 'Owner'
        }else if(data.insurance_type==='CA'){
            insuranceValue = 'Carrier'
        }
        let gstTotal = Number(data.tax_amount1) + Number(data.tax_amount2) + Number(data.tax_amount3)
        console.log(gstTotal)
        // const selectedClient = clientDetail.find(
        //     c => c.client_code === clientCode
        // );
        setClient(selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase())
        setFormValues(prev=>({
            ...prev,
            'awbNo': data.awb_no,
            'forwardingNo': data.forwarding_no,
            'date': data.booking_date,
            'subClient': data.sub_client_code,
            'tatDate':data.tat_date,
            'docType': data.document_type==='D'?'dox':'non-dox',
            'pcs': data.packets,
            'actualWt': data.actual_weight,
            'volumneWt': data.volume_weight,
            'billingWt': data.billing_weight,
            'insInvoiceNo':data.insurance_invoice_no,
            'insValue':data. insurance_value,
            'friegthAmt':data.freight_amount,
            'paymentType':data.payment_type,
            'amount': data.collect_amount,
            'codAmount': data.cod_amount,
            'codValue': data.cod_value,
            'fodAmount': data.fod_amount,
            'fodValue': data.fod_value,
            'ewayBill': data.ewaybill_no,
            'content': data.content,
            'remarks': data.remarks,
            'insurance_type':insuranceValue,
            'insRate':data.insurance_rate,
            'insAmount':data.insurance_amount,
            'insValue':data.insurance_value,
            'docketCharge':data.docket_charge,
            'consignee': data.consignee_phone,
            'service': selectedService.ser_name+" | "  + selectedService.ser_code,
            'network': selectNetwork.net_name + " | " + selectNetwork.net_code,
            'client': selectedClient.client_name.toUpperCase() + " | " + selectedClient.client_code.toUpperCase()
        }))

        setTimeout(()=>{
            setFormValues(prev=>({
            ...prev,
            'totalGst': gstTotal,
            'Total':data.total,
            'fuelAmt':data.fuel_amount,
        }))
        },300)
    }

    const checkValidation=(event)=>{
        event.preventDefault();
        setIsSaveDisable(true);
        if(formValues.awbNo===''){
            callToastWarnAlert("Enter awb number",2000)
            requestFocusOnInvalid(event,"awbNo")
            
            return;
        }

        if(formValues.client==='' || formValues.client === SELECT){
            callToastWarnAlert("Select client",2000)
            requestFocusOnInvalid(event,"client")
            return;
        }

        if(formValues.network===SELECT){
            callToastWarnAlert("Please select network",2000)
            requestFocusOnInvalid(event,"network")
            return;
        }

        if(formValues.service===SELECT){
            callToastWarnAlert("Please service network",2000)
            requestFocusOnInvalid(event,"service")
            return;
        }

        const pincodeRegex = /^[0-9]{6}$/;

        if (!pincodeRegex.test(formValues.originPincode)) {
            callToastWarnAlert("Enter valid origin pincode",2000)
            requestFocusOnInvalid(event,"originPincode")
            return;
        }else if (!pincodeRegex.test(formValues.destPincode)) {
            callToastWarnAlert("Enter valid destination pincode",2000)
            requestFocusOnInvalid(event,"destPincode")
            return;
        }

        if(formValues.originCity==='' || formValues.destCity==='' || formValues.stateCode===''){
            callToastWarnAlert("Enter valid Pincode",2000)
            return;
        }

        if(formValues.pcs<=0){
            callToastWarnAlert("Pcs can not be zero",2000)
            requestFocusOnInvalid(event,"pcs")
            return;
        }

        if(Number(formValues.actualWt)<=0){
            callToastWarnAlert("Actual weigth can not be zero",2000)
            requestFocusOnInvalid(event,"actualWt");
            return;
        }

        if(Number(formValues.volumneWt)<=0){
            callToastWarnAlert("Volume weigth can not be zero",2000)
            requestFocusOnInvalid(event,"volumneWt");
            return;
        }

        if((formValues.paymentType==='Credit' && formValues.amount<=0 || (formValues.paymentType==='CA' && formValues.amount<=0))){
            callToastWarnAlert("Friegth amount can not be zero",2000)
            return;
        }

        if(formValues.Total<=0){
            callToastWarnAlert("Total amount can not be zero",2000)
            return;
        }

        // if(formValues.paymentType==='COD' && formValues.codValue<=0){
        //     callToastErrorAlert("COD value can not be zero")
        //     requestFocusOnInvalid(event,"codValue");
        //     return;
        // }

        // if(formValues.paymentType==='FOD' && formValues.fodValue<=0){
        //     callToastErrorAlert("FOD value can not be zero")
        //     requestFocusOnInvalid(event,"fodValue");
        //     return;
        // }


        // if(formValues.paymentType==='CODFOD' && (formValues.codValue<=0 || formValues.fodValue<=0)){
        //     alert("COD & FOD value cannot be zero or negative");
        //     return
        // }

        if(formValues.paymentType==='COD'){
            setFormValues(prev=>({
                ...prev,
                'fodAmount':0.0,
                'fodValue':0.0,
            }))
        }
        else if(formValues.paymentType==='FOD'){
            setFormValues(prev=>({
                ...prev,
                'codAmount':0.0,
                'codValue':0.0
            }))
        }
        // else if(formValues.paymentType==='CODFOD'){
        //     setFormValues(prev=>({
        //         ...prev,
        //     }))
        // }

        const isOriginValid = masterData.LIST_PINCODE.find(
                                pin => pin.pin_code === formValues.originPincode
                            );
        if(isOriginValid){
            selectOriginPincode(formValues.originPincode)
        }else{
            callToastWarnAlert("Enter valid origin pincode",2000)
            requestFocusOnInvalid(event,"originPincode")
            return;
        }         
        const isDestValid = masterData.LIST_PINCODE.find(
                                pin => pin.pin_code === formValues.destPincode
                            );
        if(isDestValid){
            selectOriginPincode(formValues.destPincode)
        }else{
            callToastWarnAlert("Enter valid destination pincode",2000)
            requestFocusOnInvalid(event,"originPincode")
            return;
        }        

        handleSave();
    }

    const handleSave=async()=>{

        // setFormValues(prev => ({
        //     ...prev,
        //     billingWt: billingWeight
        // }));
        setLoading(true);
        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }

        // const actual = Number(formValues.actualWt);
        // const volume = Number(formValues.volumneWt);
        
        // if(!formValues.billingWt){
        //     const actual = Number(formValues.actualWt);
        //     const volume = Number(formValues.volumneWt);

        //     billingWeight = actual > volume ? actual : volume;
        //     setFormValues(prev=>({
        //         ...prev,
        //         'billingWt':billingWeight
        //     }))
        // }else{
            
        // }

        let awbNo = formValues.awbNo || '';
        let forwardingNo = formValues.forwardingNo?formValues.forwardingNo:formValues.awbNo;
        
        const cleintCode = formValues.client.split("|")[1].trim();
        const networkCode = formValues.network.split("|")[1].trim();
        const serviceCode = formValues.service.split("|")[1].trim();

        let subClient = formValues.subClient||'';
        let destPincode = formValues.destPincode || '';
        let destCityCode = formValues.destCityCode || '';
        let originCity = formValues.originCityCode||'';
        let originPincode = formValues.originPincode||'';
        let pcs = formValues.pcs;
        let formattedDate = '';
        let formattedTatDate = ''
        let volwt = formValues.volumneWt?formValues.volumneWt : 0.0;
        let actwt = formValues.actualWt?formValues.actualWt : 0.0;
        let billingWeight = formValues.billingWt;
        let paymentType = formValues.paymentType;

        if(modifying){
            formattedDate = formValues.date
            formattedTatDate = formValues.tatDate
        }else{
            formattedDate = formValues.date.toISOString().split('T')[0];
            formattedTatDate = formValues.tatDate.toISOString().split('T')[0];
        }
        const consigneeName = formValues.consignee.trim()
        const flagC = consigneeList.find(
            c=>c.trim().toLowerCase()===consigneeName.trim().toLowerCase()
        )
        if(flagC===undefined||flagC===''){
            // console.log(true+" consignee dont exits");
        }else{
            // console.log("already exits.");
        }
        // console.log("consignee flad: "+flagC)
        let freigthAmt = formValues.amount || 0;
        let specialEntry  = 'F';
        // if(freigthAmt>0){
        //     specialEntry = 'T'
        // }else{
        //     freigthAmt = formValues.friegthAmt||0;
        // }
        let documentType = '';
        if(formValues.docType==='dox'){
            documentType='D'
        }else{
            documentType='N'
        }

        let fuelAmt = formValues.fuelAmt||0;
        let fuelRate = formValues.fuelRate||0;
        let total = formValues.Total||0;
        let taxName1 = formValues.taxName1||'';
        let taxRate1 = formValues.taxRate1||0;
        let serviceTax = formValues.service_tax||0;
        let taxName2 = formValues.taxName2||'';
        let taxRate2 = formValues.taxRate2||0;
        let edu_cess = formValues.edu_cess||0;
        let taxName3 = formValues.taxName3||'';
        let taxRate3 = formValues.taxRate3||0;
        let h_edu_Cess = formValues.h_edu_Cess||0;
        let zoneType = '';
        let weigthType = '';
        let weigthSlab = 0;
        let serviceGroupCode = getServiceGroupCode(service)
        weigthType = formValues.WEIGHT_TYPE || '';
        weigthSlab = formValues.WEIGHT_SLAB || '';
        zoneType = formValues.lbZone || '';

        // if(specialEntry === 'F'){
            // weigthType = formValues.WEIGHT_TYPE || '';
            // weigthSlab = formValues.WEIGHT_SLAB || '';
            // zoneType = formValues.lbZone || '';
        // }
        

        // const fuelObj = await calculateFuelAmt(masterData,cleintCode,networkCode,serviceGroupCode,freigthAmt,0,formValues.insValue);
        // console.log("fuel AMount===============",fuelObj);
        let commision = 0;
        // if(weigthType==='B'){
        //     commision = getClientCommissionDetails(masterData,cleintCode,weigthSlab,freigthAmt,fuelObj.fuelAmt);
        // }else{
        //     commision = getClientCommissionDetails(masterData,cleintCode,billingWeight,freigthAmt,fuelObj.fuelAmt);
        // }
        // console.log(commision);
        const requestArr = [];
        try{

            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === formValues.client.split("|")[1].trim()
            );

            let branch = '';
            if(cookieUserType===MMB_LIVE){
                branch = selectedClient.branch_code;
            }
            // else{
            //     branch = selectedClient.client_type;
            // }
            // console.log("form",formValues)
            let column = "";
            let duplicateKeyUpdate = ''
            let tableName = '';
            let value = '';
            if(cookieUserType==="MMB_LIVE"){
                tableName = "db";
                column = "branch_code,booking_date,request_date,tat_date,awb_no,forwarding_no,client_mode,booking_type,client_code,sub_client_code,"
                    + "pincode,destination_city,network_code,service_code,document_type,packets,volume_weight,actual_weight,payment_type,"
                    + "billing_weight,freight_amount,fuel_rate,fuel_amount,total,remarks,content,vas_total,hidden_charges_ttl,tax_id,tax_amount1,tax_amount2,tax_amount3,consignor_phone,"
                    + "consignee_phone,origin_city,origin_pincode,travel_status,entry_type,special_entry,fwd_city,fwd_weight,fwd_amount,shipper_cost,"
                    + "commission,fwd_fuel,fwd_gst,sale_rate,service_group,zone_type,weight_type,weight_slab,book_issued,do_in,delivery_date,delivery_status "
                    + ",create_date,last_modify_date,application_id,last_modified_user,user_history"; 

                duplicateKeyUpdate = "  payment_type=values(payment_type),"
                    + " branch_code=values(branch_code),entry_type=values(entry_type),booking_date=values(booking_date),request_date=values(request_date),tat_date=values(tat_date),"
                    + "forwarding_no=values(forwarding_no),client_mode=values(client_mode),booking_type=values(booking_type),client_code=values(client_code),sub_client_code=values(sub_client_code),"
                    + "consignor_phone=values(consignor_phone),consignee_phone=values(consignee_phone),pincode=values(pincode),"
                    + "destination_city=values(destination_city),network_code=values(network_code),service_code=values(service_code),"
                    + "document_type=values(document_type),packets=values(packets),volume_weight=values(volume_weight),"
                    + "actual_weight=values(actual_weight),billing_weight=values(billing_weight),freight_amount=values(freight_amount),"
                    + "fuel_rate=values(fuel_rate),fuel_amount=values(fuel_amount),vas_total=values(vas_total),hidden_charges_ttl=values(hidden_charges_ttl),"
                    + "total=values(total),remarks=values(remarks),content=values(content),tax_id=values(tax_id),"
                    + "tax_amount1=values(tax_amount1),tax_amount2=values(tax_amount2),tax_amount3=values(tax_amount3),"
                    + "travel_status=values(travel_status),special_entry=values(special_entry),"
                    + "do_in=values(do_in),book_issued=values(book_issued),service_group=values(service_group),"
                    + "zone_type=values(zone_type),weight_type=values(weight_type),weight_slab=values(weight_slab),"
                    + "fwd_weight=values(fwd_weight),fwd_amount=values(fwd_amount),shipper_cost=values(shipper_cost),"
                    + "commission=values(commission),fwd_fuel=values(fwd_fuel),fwd_gst=values(fwd_gst),sale_rate=values(sale_rate),"
                    + "origin_city=values(origin_city),origin_pincode=values(origin_pincode),"
                    + "last_modify_date=values(last_modify_date),application_id=values(application_id),"
                    + "last_modified_user=values(last_modified_user)"; 
                value = `'${branch}','${formattedDate}','${formattedDate}','${formattedTatDate}','${awbNo}','${forwardingNo}',
                        'C','CREDIT','${cleintCode}','${subClient}','${destPincode}','${destCityCode}','${networkCode}','${serviceCode}',
                        '${documentType}','${pcs}','${volwt}','${actwt}','${paymentType}','${billingWeight}',
                        '${freigthAmt}','${fuelRate}','${fuelAmt}','${total}','${formValues.remarks}','${formValues.content}','0.0','0.0','1','${serviceTax}','${edu_cess}','${h_edu_Cess}','',
                        '${consigneeName}','${originCity}','${originPincode}','DE','D','${specialEntry}','${destCityCode}','${actwt}','0.0','0.0',
                        '${commision}','0.0','0.0','0.0','${serviceGroupCode}','${zoneType}','${weigthType}','${weigthSlab}','','DO',CURRENT_DATE, 'BOK', 
                        CURRENT_DATE,CURRENT_TIMESTAMP,'','${c[1]}',''` ;       
            }
            else{
                return;
            }

            const objdb = {
                tableName:tableName,
                value:value,
                column:column,
                duplicateKey:duplicateKeyUpdate
            }

            requestArr.push(objdb);
            
            const objdbv = saveDailyBookingVas();
            requestArr.push(objdbv);

            const requestOption = {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(requestArr),
                    key:"checkService",
                    userKey:c[0]
                })
            }

            const path = API_PATH  + FAST_BOOKING_REQUEST_PATH  + "saveentry";
            const res = await fetch(path,requestOption);
            const data = await res.json();

            // console.log("data db and dbv "+data);
            if(data==='Entry saved.'){
                if(cookieUserType===MMB_LIVE){
                    if(!modifying){
                        saveDailyBookingStatusSummary();
                    }
                    saveEWayBill(); 
                }
                saveWeigthDimension();  
                if(printDocket){
                    printJasper(cleintCode,formValues.awbNo)
                    console.log("just called print api");
                }else{
                    console.log("not calling print api");
                }
                // alert(data);
                const message = `Awb: ${formValues.awbNo} booked successfully.`
                callToastSuccessAlert(message);
                resetAction();
            }else{
                callToastErrorAlert(data)
            }

            
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    const printJasper=async(clientCode,awbNo)=>{
        try{
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let value = '';
            if(cookieUserType==="MMB_LIVE"){
                console.log("Returning print api for fun");
                value = "where db.awb_no='"+awbNo+"' and db.client_code='" +clientCode+"'";
            }else{
                // value = "where cb.awb_no='"+awbNo+"' and client_cd='" +clientCode+"'";
                return;
            }
            const requestObj = {"userKey":c[0],"value":value}
            const requestOption = {
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(requestObj),
                    key:"checkService",
                    userType:cookieUserType
                })
            }

            const path = API_PATH  + FAST_BOOKING_DOCKETJASPER + "jasperprint";
            const response = await fetch(path, requestOption);
            const contentType = response.headers.get("Content-Type");
            console.log(contentType);
            if(contentType && contentType.includes('application/octet-stream')){
                    const arrayBuffer = await response.arrayBuffer();
                    const blob = new Blob([arrayBuffer], { type: 'application/pdf' })
                    const url = URL.createObjectURL(blob);

                    // Open PDF immediately
                    window.open(url, "_blank", "noopener,noreferrer,width=800,height=600");
            }else{
                const errText = await response.text();
                alert(errText)
            }

            
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    const resetAction=()=>{
        let client = masterData.LIST_CLIENT[0];
        setFormValues({
            awbNo:'',
            forwardingNo:'',
            date:date,
            tatDate:date,
            client:`${client.client_name.toUpperCase() + " | " + client.client_code.toUpperCase()}`,
            subClient:'',
            network:SELECT,
            service:SELECT,
            originPincode:'',
            originCity:'',
            originCityCode:'',
            destPincode:'',
            destCity:'',
            destCityCode:'',
            stateCode:'',
            docType:'dox',
            lbZone:'',
            pcs:'',
            actualWt:'',
            volumneWt:'',
            billingWt:'',
            insInvoiceNo:'',
            insValue:'',
            insAmount:0,
            insRate:0,
            insurance_type:'NA',
            paymentType:'Credit',
            amount:'',
            codValue:'',
            codAmount:'',
            fodValue:'',
            fodAmount:'',
            ewayBill:'',
            content:'',
            remarks:'',
            consignee:'',
            WEIGHT_SLAB:'',
            WEIGHT_TYPE:'',
            rate_format:'',
            docketCharge:0,
            fuelAmt:0,
            fuelRate:0,
            taxName1:'',
            taxRate1:0,
            service_tax:0,
            taxName2:'',
            taxRate2:0,
            edu_cess:0,
            taxName3:'',
            taxRate3:0,
            h_edu_Cess:0,
            totalGst:0,
            Total:0,
            clientCode:getCookie(USER_TYPE_COOKIE_NAME) === US ? getCookie(LOGIN_COOKIE_NAME).split(LOGIN_COOKIE_NAME_SPLITBY)[1] : '',
            userType: getCookie(APP_TYPE_COOKIE_NAME)
        })

        setWeigthDimension({
            heigth:'',
            width:'',
            length:'',
            actwt:'',
            pcs:'',
            volwt:''
        })
        setPrintDocket(false);
        setIsSameAwb('');

        setDimensionList([]);
        // setPiece(0);

        setEWayBillObj({
            'awb_no':'',
            'ewayBill':'',
            'invNo':'',
            'invDate':'',
            'invValue':'',
            'validity':'',
            'ewaybillapi':false
        })
        setEWayBillLIst([]);

        if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){

        }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
            // setClientByUs();
        }

        setDisableAwb(false);
        setModifying(false);
        setModifyingData({});
        setWeigthModifying(false);
        setModifyingWeigth([])
        setIsModifyingDisable(false);
        setIsSaveDisable(true)
        setModifyingEWayBillData([]);
        setEWayBillModifying(false);
    }

    const saveDailyBookingVas=()=>{

        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        let docketCharge = formValues.docketCharge||0;
        let insuranceType = '';
        if(formValues.insurance_type === 'Owner'){
            insuranceType = 'OW';
        }else if(formValues.insurance_type === 'Carrier'){
            insuranceType = 'CA'
        }else{
            insuranceType = 'NA'
        }

        let column = '';
        let tableName=  '';
        let duplicateKeyUpdate  ='';
        let value = '';

        if(cookieUserType==='MMB_LIVE'){
            tableName = "dbv"
            column = "awb_no,ewaybill_no,collect_amount,insurance_invoice_no,insurance_type,insurance_rate,insurance_value,"
            + "insurance_amount,cod_value,cod_amount,fod_value,fod_amount,docket_charge,ahc_amount,non_tax_vas_detail,other_vas_detail,other_total_amount,"
            + "dimension_detail,oda_amount,opa_amount,oss_amount,create_date,"
            + "last_modify_date,application_id,last_modified_user,user_history";

            value = `'${formValues.awbNo}','${formValues.ewayBill}','${formValues.amount?formValues.amount:0.0}','${formValues.insInvoiceNo}','${insuranceType}','${formValues.insRate||0}','${formValues.insValue?formValues.insValue:0.0}',
            '${formValues.insAmount||0}','${formValues.codValue?formValues.codValue:0.0}','${formValues.codAmount?formValues.codAmount:0.0}','${formValues.fodValue?formValues.fodValue:0.0}','${formValues.fodAmount?formValues.fodAmount:0.0}','${docketCharge}','0.0','','','0.0',
            '0','0','0','0',CURRENT_DATE,CURRENT_TIMESTAMP,'1','',''`;

            duplicateKeyUpdate = " insurance_invoice_no=values(insurance_invoice_no),collect_amount=values(collect_amount),ewaybill_no=values(ewaybill_no),"
                + "  insurance_type=values(insurance_type),insurance_rate=values(insurance_rate),insurance_value=values(insurance_value),"
                + "insurance_amount=values(insurance_amount),cod_value=values(cod_value),cod_amount=values(cod_amount),fod_value=values(fod_value),"
                + "fod_amount=values(fod_amount),docket_charge=values(docket_charge),ahc_amount=values(ahc_amount),non_tax_vas_detail=values(non_tax_vas_detail),other_vas_detail=values(other_vas_detail),"
                + "other_total_amount=values(other_total_amount) ,dimension_detail=values(dimension_detail),oda_amount=values(oda_amount),opa_amount=values(opa_amount),"
                + "oss_amount=values(oss_amount),last_modify_date=values(last_modify_date),application_id=values(application_id),last_modified_user=values(last_modified_user),user_history=values(user_history)";
        }else{
            return;
        }

         

        const obj={
            value:value,
            column:column,
            tableName:tableName,
            duplicateKey:duplicateKeyUpdate
        }

        return obj;

    }

    const saveDailyBookingStatusSummary=async()=>{

        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        let column = '';
        let tableName = '';
        if(cookieUserType === 'MMB_LIVE'){
            column = "awb_no, pcs, status_date, status_time, delivery_status, branch_code, active_status, create_date, last_modify_date, application_id, last_modified_user, user_history";
            tableName = "dbss";
        }else if(cookieUserType==='MMB'){
            return;
        }

        const value = `'${formValues.awbNo}','${formValues.pcs}',CURRENT_DATE,CURRENT_TIME,'BOK','${c[3]}','T',CURRENT_DATE,CURRENT_TIMESTAMP,'','',''`;
        
        const query={
            tableName:tableName,
            value:value,
            column:column,
        }

        const requestOption = {
        method:"POST",
        headers:{
            "Content-Type":"application/json"
        },
        body: new URLSearchParams({
            query:JSON.stringify(query),
            userKey:c[0],
            key:"checkService"
        })
    }

        const path = API_PATH  + FAST_BOOKING_REQUEST_PATH  + "savedbss";
        const res = await fetch(path,requestOption);
        const data = await res.json();
        // console.log("data dbss "+data);
        
    }

    const saveWeigthDimension = async () => {

        if (dimensionList.length === 0) return;

        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        let requestArr = [];

        if (cookieUserType === 'MMB_LIVE') {

            let count = 1;
            const masterNo = formValues.awbNo;

            requestArr = dimensionList.map(value => {

                const subAwb = masterNo+"-000" + count++;

                return {
                    master_awb_no: masterNo,
                    sub_awb_no: subAwb,
                    height: Number(value.heigth),
                    width: Number(value.width),
                    length: Number(value.length),
                    pcs: Number(value.pcs),
                    act_wt: Number(value.actwt),
                    vol_wt: Number(value.volwt),
                };
            });
        }else if(cookieUserType===MMB){
            return;
            // const masterNo = formValues.awbNo;

            // requestArr = dimensionList.map(value => {
            //     return {
            //         awb_no: masterNo,
            //         height: Number(value.heigth),
            //         width: Number(value.width),
            //         length: Number(value.length),
            //         pcs: Number(value.pcs),
            //         weigth: Number(value.volwt),
            //         act_wt: Number(value.actwt),
            //     };
            // });
        }

        try {

            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(requestArr),
                    key:"checkService",
                    userKey:c[0],
                    masterAwb:formValues.awbNo,
                    apptype:cookieUserType
                })
            };

            const path = API_PATH + WEIGTH_DIMENSION + "save";
            const res = await fetch(path, requestOption);
            const data = await res.json();

            // console.log("dw "+data);

        } catch (error) {
            console.log(error);
        }
    };

    const saveEWayBill=async()=>{
        // console.log('ewaybill obj list',eWayBillList)
        if(eWayBillList.length===0)return;

        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        let requestArr = [];

        if (cookieUserType === 'MMB_LIVE') {

            let count = 1;
            const masterNo = formValues.awbNo;

            requestArr = eWayBillList.map(value => {
                let api = value.ewaybillapi
                const invDate  = value.invDate?"'"+value.invDate+"'":null;
                const validity = value.validity?"'"+value.validity+"'":null;
                return {
                    'value': `'${masterNo}','${value.ewayBill}','${api}','${value.invNo?value.invNo:''}',null,'',${invDate},'${value.invValue?value.invValue:0}',${validity}`
                };
            });
        }

        try {

            const requestOption = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: new URLSearchParams({
                    query:JSON.stringify(requestArr),
                    key:"checkService",
                    userKey:c[0],
                    masterAwb:formValues.awbNo,
                })
            };

            const path = API_PATH + EWAY_BILL + "save";
            const res = await fetch(path, requestOption);
            const data = await res.json();

            // console.log("ewaybill "+data);

        } catch (error) {
            console.log(error);
        }
    }

    const enterEWayBillNumber = ()=>{
        const ewaybil = ewaybillObj.ewayBill;
        const api = ewaybillObj.ewaybillapi?'T':'F';
        if(ewaybil.length<12)return alert("Please Enter 12 Digit E-Way Bill Number")
        if(ewaybil<=0) return alert("Enter E-Way Bill Number")
        const isEWayBillExits = eWayBillList.some(e=>e.ewayBill===ewaybil);
        if(isEWayBillExits)return alert("E Way bill already entered.");    

        setEWayBillLIst(prev => {

            const updatedList = [
                ...prev,
                {
                    ...ewaybillObj,
                    awb_no:formValues.awbNo,
                    ewayBill: ewaybil,
                    ewaybillapi:api
                }
            ];

            return updatedList;
        });

        setFormValues(prev=>({
            ...prev,
            'ewayBill':eWayBillList[0]?.ewayBill?eWayBillList[0].ewayBill:ewaybil
        }))
        // console.log(ewaybillObj);

        setEWayBillObj(prev=>({
            'awb_no':'',
            'ewayBill':'',
            'invNo':'',
            'invDate':'',
            'invValue':'',
            'validity':'',
            'ewaybillapi':false
        }))
    }

    // const [peice,setPiece] = useState(0);
    const enterDimensionMMB_LIVE = () => {

        const actwt = Number(weigthDimension.actwt);
        const length = Number(weigthDimension.length);
        const width  = Number(weigthDimension.width);
        const heigth = Number(weigthDimension.heigth);
        const pcs    = Number(weigthDimension.pcs);
        const totalPcs = Number(formValues.pcs);

        if (heigth <= 0) return alert("Height cannot be zero or negative");
        if (width  <= 0) return alert("Width cannot be zero or negative");
        if (length <= 0) return alert("Length cannot be zero or negative");
        if (actwt  <= 0) return alert("Actual weight cannot be zero or negative");

        let mode = '';
        let service = '';
        if(formValues.service!=="Select..."){
            service = formValues.service.split("|")[1].trim();
        }else{
            // setPiece(0);
            return alert("Please Select Service.");
        }

        // setPiece(peice+pcs)

        const currTotalPcs = dimensionList.reduce((total, item) => {
            return total + Number(item.pcs);
        }, 0);

        if(currTotalPcs+pcs>totalPcs) return alert("Weigth Dimension Pcs is greater than actual pcs");

        // if (pcs > formValues.pcs) {
        //     alert("Pcs is greater than " + formValues.pcs);
        //     return;
        // }
        

        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === service
        );

        if (selectedService) {
            mode = selectedService.ser_mode;
        }

        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === formValues.client.split("|")[1].trim()
        );

        if (!selectedClient) {
            alert("Client not found");
            return;
        }

        let dimantion = 0;
        let wtRoundOff = false;

        if (selectedClient) {
            if (mode === "AR" || mode === "AC") dimantion = selectedClient.air_dimension;
            else if (mode === "SF") dimantion = selectedClient.surface_dimension;
            else if (mode === "TR") dimantion = selectedClient.train_dimension;
            else if (mode === "IN") dimantion = selectedClient.intl_dimension;
            else if (mode === "LG") dimantion = selectedClient.logistic_cft;

            wtRoundOff = selectedClient.wt_round_off === "Y";
        }

        if (!dimantion) {
            alert("Dimension factor not found");
            return;
        }

        let weigth = (heigth * width * length) / dimantion;

        weigth = wtRoundOff ? Math.ceil(weigth) : Number(weigth.toFixed(2));

        setDimensionList(prev => {

            const updatedList = [
                ...prev,
                {
                    ...weigthDimension,
                    volwt: weigth
                }
            ];

            const totalactwt = updatedList.reduce(
                (total, item) => total + Number(item.actwt),
                0
            );

            const totalVolwt = updatedList.reduce(
                (total, item) => total + Number(item.volwt),
                0
            );

            setFormValues(prevForm => ({
                ...prevForm,
                actualWt: totalactwt,
                volumneWt: totalVolwt
            }));

            return updatedList;
        });

        setWeigthDimension({
            heigth:'',
            width:'',
            length:'',
            actwt:'',
            pcs:'',
            volwt:''
        })

    };

        const enterDimensionMMB = () => {

        const actwt = Number(weigthDimension.actwt);
        const length = Number(weigthDimension.length);
        const width  = Number(weigthDimension.width);
        const heigth = Number(weigthDimension.heigth);
        const pcs    = Number(weigthDimension.pcs);
        const totalPcs = Number(formValues.pcs);

        if (heigth <= 0) return alert("Height cannot be zero or negative");
        if (width  <= 0) return alert("Width cannot be zero or negative");
        if (length <= 0) return alert("Length cannot be zero or negative");
        if (actwt  <= 0) return alert("Actual weight cannot be zero or negative");

        let mode = '';
        let service = '';
        if(formValues.service!=="Select..."){
            service = formValues.service.split("|")[1].trim();
        }else{
            // setPiece(0);
            return alert("Please Select Service.");
        }

        let network = '';
        if(formValues.network!=="Select..."){
            network = formValues.network.split("|")[1].trim();
        }else{
            alert("Please select network.")
            return;
        }

        // setPiece(peice+pcs)

        const currTotalPcs = dimensionList.reduce((total, item) => {
            return total + Number(item.pcs);
        }, 0);

        if(currTotalPcs+pcs>totalPcs) return alert("Weigth Dimension Pcs is greater than actual pcs");

        // if (pcs > formValues.pcs) {
        //     alert("Pcs is greater than " + formValues.pcs);
        //     return;
        // }
        

        const selectedService = masterData.LIST_SERVICE.find(
            t => t.ser_code === service
        );

        const clientVas = masterData.LIST_CLIENTVAS.find(
            t => t.client_code === formValues.client.split("|")[1].trim()
        );

        const selectedClient = masterData.LIST_CLIENT.find(
            c => c.client_code === formValues.client.split("|")[1].trim()
        );
        if (!clientVas) {
            alert("Client data not found");
            return;
        }

        // let fg = 0;
        // if(selectedClient.dimention_type==="C"){
        //     if ("SF".equals(selectedService.ser_mode)) {
        //         fg = selectedClient.surface_dimension ;
        //     } else {
        //         fg = selectedClient.air_dimension;
        //     }
        // }else{
        //     fg = getServiceAssociatMMBDataFromDb(network,service);
        // }

        let dimantion = 0;
        let wtRoundOff = false;
        let wt = 0;
        if(clientVas.dimension_type==='DIM'){
            wt = clientVas.dimension_value;
        }else{
            wt = clientVas.dimension_value;
        }

        if(wt===0){
            alert("Error, Dimension value is not set on Client, Network, or Service..");
        }else{
            if(clientVas.dimension_type==='DIM'){
                dimantion = (heigth * width * length * pcs)/wt;
            }else{
                let weigth;
                weigth = ((heigth*width*length)/27000)*wt;
                dimantion = weigth*pcs;
            }
        }

        if (!dimantion) {
            alert("Dimension factor not found");
            return;
        }
        
        let weigth = wtRoundOff ? Math.ceil(dimantion) : Number(dimantion.toFixed(2));

        setDimensionList(prev => {

            const updatedList = [
                ...prev,
                {
                    ...weigthDimension,
                    volwt: weigth
                }
            ];

            const totalactwt = updatedList.reduce(
                (total, item) => total + Number(item.actwt),
                0
            );

            const totalVolwt = updatedList.reduce(
                (total, item) => total + Number(item.volwt),
                0
            );

            setFormValues(prevForm => ({
                ...prevForm,
                actualWt: totalactwt,
                volumneWt: totalVolwt
            }));

            return updatedList;
        });

        setWeigthDimension({
            heigth:'',
            width:'',
            length:'',
            actwt:'',
            pcs:'',
            volwt:''
        })

    };


    const removeEnteredDimension = (index) => {

        if (window.confirm("Do you want to remove this row?")) {

            const updatedList = dimensionList.filter((_, i) => i !== index);

            setDimensionList(updatedList);

            const totals = updatedList.reduce((acc, item) => {
                acc.act += Number(item.actwt || 0);
                acc.vol += Number(item.volwt || 0);
                return acc;
            }, { act: 0, vol: 0 });

            setFormValues(prev => ({
                ...prev,
                actualWt: totals.act,
                volumneWt: totals.vol
            }));
        }
    };

    const removeEnteredEWayBill = (index) => {

        if (window.confirm("Do you want to remove this row?")) {

            const updatedList = eWayBillList.filter((_, i) => i !== index);

            setEWayBillLIst(updatedList);
            setFormValues(prev=>({
                ...prev,
                'ewayBill':updatedList[0]?.ewayBill?updatedList[0].ewayBill:''
            }))
        }
    };


    const [modifyingWeigth,setModifyingWeigth] = useState([]);
    const [weigthModifying,setWeigthModifying] = useState(false);

    const handleWeigthDimenstionFocus=async()=>{
        if(formValues.awbNo==='') return;
        if(weigthModifying)return;
        try{
            checkSession(store);
            if (!getCookie(LOGIN_SESSION_NAME)) {
                return;
            }
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let column=''
            let condition = ''
            let tableBean = ''
            if (c.length === 4) {

                if(cookieUserType==='MMB_LIVE'){
                    column = "master_awb_no,sub_awb_no,height,width,lenght,pcs,act_wt,vol_wt,division ";
                    tableBean = "DataEntryBean";
                    condition = "where master_awb_no='" + formValues.awbNo + "'";
                }else if(cookieUserType==='MMB'){
                    // column = "awb_no,height,width,length,pcs,act_weight as act_wt,weight as vol_wt";
                    // tableBean = "DataEntryBean";
                    // condition = "where awb_no='" + formValues.awbNo + "'";
                    return;
                }

                let query = { "userKey": c[0], 'column':column,'value':condition,'beanname':tableBean};
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query),
                        key:"checkService",
                        usertype:cookieUserType
                    })
                };
                const path = API_PATH + WEIGTH_DIMENSION + "getweigthData";
                const res = await fetch(path, requestOptions);
                const data = await res.json();

                const response = data[0][tableBean];
                console.log("weigth",response);
                if(response!=="Result Not Found"){
                    setWeigthModifying(true)
                    setModifyingWeigth(response);
                    
                    for(let i of response){
                        if(cookieUserType===MMB_LIVE){
                            setDimensionList(prev => {

                                const updatedList = [
                                    ...prev,
                                    {
                                        heigth:i.height,
                                        width:i.width,
                                        length:i.lenght,
                                        actwt:i.act_wt,
                                        pcs:i.pcs,
                                        volwt:'',
                                        master_awb_no:i.master_awb_no,
                                        sub_awb_no:i.sub_awb_no,
                                        volwt: i.vol_wt
                                    }
                                ];

                                const totalactwt = updatedList.reduce(
                                    (total, item) => total + Number(item.actwt),
                                    0
                                );

                                const totalVolwt = updatedList.reduce(
                                    (total, item) => total + Number(item.volwt),
                                    0
                                );

                                setFormValues(prevForm => ({
                                    ...prevForm,
                                    actualWt: totalactwt,
                                    volumneWt: totalVolwt
                                }));

                                return updatedList;
                            });
                        }else if(cookieUserType===MMB){
                            setDimensionList(prev => {

                                const updatedList = [
                                    ...prev,
                                    {
                                        heigth:i.height,
                                        width:i.width,
                                        length:i.length,
                                        actwt:i.act_wt,
                                        pcs:i.pcs,
                                        master_awb_no:i.awb_no,
                                        volwt: i.vol_wt
                                    }
                                ];

                                const totalactwt = updatedList.reduce(
                                    (total, item) => total + Number(item.actwt),
                                    0
                                );

                                const totalVolwt = updatedList.reduce(
                                    (total, item) => total + Number(item.volwt),
                                    0
                                );

                                setFormValues(prevForm => ({
                                    ...prevForm,
                                    actualWt: totalactwt,
                                    volumneWt: totalVolwt
                                }));

                                return updatedList;
                            });
                        }
                    }
                }
            }
        }catch(error){
            console.log(error);
        }
    }

    const [eWayBillModifying,setEWayBillModifying] = useState(false);
    const [modifyingEWayBillData,setModifyingEWayBillData] = useState([]);
    const handleEWayBillFocus=async()=>{
        if(formValues.awbNo==='')return;
        if(eWayBillModifying)return;
        try{

            checkSession(store);
            if (!getCookie(LOGIN_SESSION_NAME)) {
                return;
            }
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            let column=''
            let condition = ''
            let tableBean = ''
            if (c.length === 4) {

                if(cookieUserType==='MMB_LIVE'){
                    column = "awb_no, ewaybill_no, ewb_api, ewb_invoice_no,ewb_vehicle_update,cewaybill_no, ewb_invoice_date, ewb_invoice_value, ewb_validity";
                    tableBean = "DataEntryBean";
                    condition = "where awb_no='" + formValues.awbNo + "'";
                }else if(cookieUserType==='MMB'){
                    return alert("Not found");
                }

                let query = { "userKey": c[0], 'column':column,'value':condition,'beanname':tableBean};
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query),
                        key:"checkService"
                    })
                };
                const path = API_PATH + EWAY_BILL + "getdataviaawb";
                const res = await fetch(path, requestOptions);
                const data = await res.json();
                // console.log("eway",data)
                const response = data[0][tableBean];
                if(response!=="Result Not Found"){
                    setEWayBillModifying(true)
                    setModifyingEWayBillData(response);
                    for(let i of response){
                         setEWayBillLIst(prev => {
                                const updatedList = [
                                    ...prev,
                                    {
                                        awb_no:i.awb_no,
                                        ewayBill:i.ewaybill_no,
                                        ewaybillapi:i.ewb_api,
                                        invNo:i.ewb_invoice_no,
                                        invDate:i.ewb_invoice_date,
                                        invValue:i.ewb_invoice_value,
                                        validity: i.ewb_validity
                                    }
                                ];

                                return updatedList;
                            });
                    }
                }
            }
        }catch(err){
            console.log(err);
        }
    }

    // ===========================================Alert message dailog==============================================================

        const callToastWarnAlert=(message,duration)=>{
            toast.warn(message, {
                autoClose: duration,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    
        const callToastSuccessAlert=(message,duration)=>{
            toast.success(message, {
                autoClose: duration,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } 
    
        const callToastErrorAlert=(message,duration)=>{
            toast.error(message, {
                autoClose: duration,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } 

// ===============================focus fields=========================================
const requestFocusOnInvalid=(e,name)=>{
e.preventDefault();
const form = e.target.form;
const elements = Array.from(form.elements);
// const index = elements.indexOf(e.target);
for (let i = 0; i < elements.length; i++) {
    if(elements[i].name===name){
        elements[i].focus();
        break;
    }
}
}

    // ================================ enter ===============================================================================

    const handleEnterAsTab = async(e) => {
    if (
        e.key === "Enter" &&
        e.target.tagName !== "TEXTAREA"
    ) {
        e.preventDefault();

        const form = e.target.form;
        const elements = Array.from(form.elements);
        const index = elements.indexOf(e.target);

        if(elements[index].name === 'awbNo'){
            setIsSaveDisable(true);
            awbBlurHandle(e);
        }
        else if(elements[index].name === 'client'){
            setIsSaveDisable(true);
            let clientCode = formValues.client?.split('|')[1]?.trim();

            for(const clientBean of masterData.LIST_CLIENT){
                if(clientBean.client_code === clientCode){
                    console.log("for setting client zip code ",clientBean.zip_code);
                    selectOriginPincode(clientBean.zip_code||'');
                }
            }
            
            const docketSeries = await loadDoketChargedBySeries(clientCode);  // docket series
            setDocketSeriesRate(docketSeries);
        }
        else if(elements[index].name === 'network'){
            setIsSaveDisable(true);
            // console.log(formValues.client+" for network");
            if(formValues.network == SELECT){
                callToastWarnAlert("Please Select Network",2000);
                requestFocusOnInvalid(e,'network')
                return
            }
            
        }
        else if(elements[index].name === 'service'){
            setIsSaveDisable(true);
            if(formValues.service == SELECT){
                callToastWarnAlert("Please Select Service",2000);
                requestFocusOnInvalid(e,'service')
                return;
            }
            if(formValues.network == SELECT){
                callToastWarnAlert("Please Select Network",2000);
                requestFocusOnInvalid(e,'network')
                return
            }
            // setInsuranceTypeViaClientCode();
            setAutoInsuranceAndDockt()
        }
        else if(elements[index].name === 'insValue'){
            setIsSaveDisable(true);
            if(formValues.service == SELECT){
                callToastWarnAlert("Please Select Service",2000);
                requestFocusOnInvalid(e,'service')
                return;
            }
            if(formValues.network == SELECT){
                callToastWarnAlert("Please Select Network",2000);
                requestFocusOnInvalid(e,'network')
                return
            }
            if(Number(formValues.insValue||0)>0){
                calculateInsuranceAmount();
            }else{
                setFormValues(prev=>({
                    ...prev,
                    'insRate':0,
                    'insAmount':0
                }))
            }
        }
        else if(elements[index].name === 'codValue'){
            if(formValues.service == SELECT){
                callToastWarnAlert("Please Select Service",2000);
                requestFocusOnInvalid(e,'service')
                return;
            }
            if(formValues.network == SELECT){
                callToastWarnAlert("Please Select Network",2000);
                requestFocusOnInvalid(e,'network')
                return
            }

            let codAmt = 0;
            if(formValues.codValue>0){
                codAmt = calculateCodAmount();
            }else{
                setFormValues(prev=>({
                    ...prev,
                    'codAmount':0
                }))
            }

            console.log(codAmt)
            let friegthAmt = Number(formValues.friegthAmt||0);
            let subVasTotal = Number(formValues.insAmount||0) + Number(formValues.docketCharge||0) + Number(codAmt||0) + Number(formValues.fodAmount||0);
            console.log( Number(formValues.insAmount||0) , Number(formValues.docketCharge||0),  Number(codAmt||0), Number(formValues.fodAmount||0))
            console.log(friegthAmt)
            let fuelAmt = calculateFuel(friegthAmt,subVasTotal);
            await calculateGST(friegthAmt,subVasTotal,fuelAmt);
            if(isModifyingDisable){
                setIsSaveDisable(true);
            }else{
                setIsSaveDisable(false);
            }
        }
        else if(elements[index].name === 'fodValue'){
            if(formValues.service == SELECT){
                callToastWarnAlert("Please Select Service",2000);
                requestFocusOnInvalid(e,'service')
                return;
            }
            if(formValues.network == SELECT){
                callToastWarnAlert("Please Select Network",2000);
                requestFocusOnInvalid(e,'network')
                return
            }

            

            let fodAmt = 0;
            if(formValues.fodValue>0){
                fodAmt = calculateFodAmount();
            }else{
                setFormValues(prev=>({
                    ...prev,
                    'fodAmount':0
                }))
            }
            console.log(fodAmt)
            let friegthAmt = Number(formValues.friegthAmt||0);
            let subVasTotal = Number(formValues.insAmount||0) + Number(formValues.docketCharge||0) + Number(formValues.codAmount||0) + Number(fodAmt||0);
    

            let fuelAmt = calculateFuel(friegthAmt,subVasTotal);
            await calculateGST(friegthAmt,subVasTotal,fuelAmt);
            if(isModifyingDisable){
                setIsSaveDisable(true);
            }else{
                setIsSaveDisable(false);
            }
        }

        if(elements[index].name === 'saveBtn'){
            checkValidation(e);
            console.log(elements[index].name)
            requestFocusOnInvalid(e,'awbNo');
            setIsSaveDisable(true);
            return;
        }
        else if(elements[index].name ==='originPincode'){
            setIsSaveDisable(true);
            if (
                activeOriginIndex >= 0 &&
                activeOriginIndex < filteredOriginPincodes.length
            ) {
                selectOriginPincode(filteredOriginPincodes[activeOriginIndex]);
            }
            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];

            const isValid = masterData.LIST_PINCODE.find(
                pin => pin.pin_code === pincodeValue
            );

            if (!isValid) {
                elements[index].focus();
                return;
            }
        }
        else if(elements[index].name === 'destPincode'){
            setIsSaveDisable(true);
            if (
                activeDestIndex >= 0 &&
                activeDestIndex < filteredDestPincodes.length
            ) {
                selectDestPincode(filteredDestPincodes[activeDestIndex]);
            }
            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];

            const isValid = masterData.LIST_PINCODE.find(
                pin => pin.pin_code === pincodeValue
            );

            if (!isValid) {
                elements[index].focus();
                return;
            }else{
                checkClientRateFormatForFriegth();
            }
        }
        else if(elements[index].name === 'pcs'){
            setIsSaveDisable(true);
            if(!formValues.pcs){
                setFormValues(prev=>({
                    ...prev,
                    'pcs':1
                }))
            }
        }
        else if(elements[index].name === 'actualWt'){
            setIsSaveDisable(true);
            if(!formValues.actualWt){
                setFormValues(prev=>({
                    ...prev,
                    'actualWt': "0.100"
                }))
            }
        }
        else if(elements[index].name === 'volumneWt'){
            setIsSaveDisable(true);
            // handleBlurOfVolumeWt();
            if(!formValues.volumneWt){
                setFormValues(prev=>({
                    ...prev,
                    'volumneWt': "0.100"
                }))
            }
            const rateFormat = formValues.rate_format;
            console.log("new form valye rate format ", rateFormat);
            if(rateFormat === 'B' || rateFormat === ''){
                calculateFriegthAmtFromDb();
            }else if(rateFormat === 'K'){
                calculateFriegthAmountFromLogistic();
            }
        }
        else if(elements[index].name === 'paymentType'){
            if(formValues.paymentType === 'Credit' || formValues.paymentType === 'CA'){
                if(formValues.service == SELECT){
                    callToastWarnAlert("Please Select Service",2000);
                    requestFocusOnInvalid(e,'service')
                    return;
                }
                if(formValues.network == SELECT){
                    callToastWarnAlert("Please Select Network",2000);
                    requestFocusOnInvalid(e,'network')
                    return
                }

                let friegthAmt = Number(formValues.friegthAmt||0);
                let subVasTotal = Number(formValues.insAmount||0) + Number(formValues.docketCharge||0) + Number(formValues.codAmount||0) + Number(formValues.fodAmount||0);
        

                let fuelAmt = calculateFuel(friegthAmt,subVasTotal);
                await calculateGST(friegthAmt,subVasTotal,fuelAmt);
                if(isModifyingDisable){
                    setIsSaveDisable(true);
                }else{
                    setIsSaveDisable(false);
                }
            }
        }
        else if(elements[index].name === 'consignee'){
            if (
                activeConsigneeIndex >= 0 &&
                activeConsigneeIndex < filterConsignee.length
            ) {
                selectConsignee(filterConsignee[activeConsigneeIndex]);
            }
        }else if(elements[index].name === 'date'){
            setIsSaveDisable(true);
            dateRef.current.setOpen(false);
        }

        for (let i = index + 1; i < elements.length; i++) {
            if (
                elements[i].focus &&
                !elements[i].disabled &&
                elements[i].type !== "hidden"
            ) {
                elements[i].focus();
                break;
            }
        }
    }
};


// ===================================================================================================================

const getRateFormatViaClientCode=(client)=>{
    let rateFormate = "";
    if(!client){
        return rateFormate;
    }
    
    for(const clientBean in list_client){
        const bean = list_client[clientBean];
        if(client.trim() === bean.client_code){
            rateFormate =  bean.rate_format;
            break;
        }
    }

    return rateFormate;
}

const getRateTypeViaClientCode=(clientCode)=>{
    let rateType = "";
    for(const clientBean in masterData.LIST_CLIENT){
        const client = masterData.LIST_CLIENT[clientBean];

        if(client.client_code === clientCode){
            rateType = client.rate_type;
            break;
        }
    }

    return rateType;
}

const getServiceGroupCode=(service)=>{
    let groupCode = "";
    for(const serviceBean in masterData.LIST_SERVICE){
        const bean = masterData.LIST_SERVICE[serviceBean];
        if(service === bean.ser_code){
            groupCode = bean.group_code;
            break;
        }
    }
    return groupCode;
}

const getAwbPrefix=()=>{
    const awbNo = formValues.awbNo || "";
    let prefix = "";
    for(let i=0;i<awbNo.length;i++){
        if (/[a-zA-Z]/.test(awbNo.charAt(i))) {
            prefix += awbNo.charAt(i);
        }
    }

    return prefix;
}

const docketCharge =(clientCode, awbPrefix)=>{
    const docketSeries =  docketSeriesRate;
    let amount = 0;
    if(docketSeries.length>0){
        for(const docketSeriesIndex in docketSeries){
            const bean = docketSeries[docketSeriesIndex];

            if(bean.client_code === clientCode && bean.series === awbPrefix){
                amount = bean.amount;
                break;
            }
        }
    }else{
    console.log("docket is empty")
    }

    return amount;
}

const basicRateFormula=(B_slno, B_zoneAmount)=>{
    let basicAmt = 0;
    if (B_slno != 0) {
        basicAmt = B_zoneAmount;
    }
    return basicAmt;
}

const addRateFormula=(E_slno, E_zoneAmount, B_nearest, E_nearest, billWt)=>{
    let addAmt = 0;
    if (E_slno != 0) {
        addAmt = E_zoneAmount * Math.ceil((billWt - B_nearest) / E_nearest);
    }

    return addAmt;
}

const kgRateFormula=(K_slno, K_zoneAmount, rateType, billWt, pcs)=>{
    let kgAmt = 0;
    if (K_slno != 0) {
        if (rateType == null) {
            kgAmt = Math.ceil(billWt) * K_zoneAmount;
        } else if (rateType.equals("KG")) {
            kgAmt = Math.ceil(billWt) * K_zoneAmount;
        } else if (rateType.equals("PCS")) {
            kgAmt = pcs * K_zoneAmount;
        }
    }
    return kgAmt;
}

// ===================================================================================================================================


// const setInsuranceTypeViaClientCode=()=>{

//     let client = formValues.client?.split("|")[1]?.trim();
//     let network = formValues.network?.split("|")[1]?.trim();
//     let service = formValues.service?.split("|")[1]?.trim();

//     let hashmap_clientVas = new Map();

//     for(let clientVas of masterData.LIST_CLIENTVAS){
//         if(clientVas.client_code === client){
//             if (clientVas.service_group_code === service && clientVas.network_code === network) {

//                 console.log("clientVas",clientVas)
//                 let insuranceType = "NA";
//                 if(clientVas.insurance_type==='OW'){
//                     insuranceType = "Owner";
//                 }else if(clientVas.insurance_type === 'CA'){
//                     insuranceType = "Carrier";
//                 }
//                 setFormValues(prev=>({
//                     ...prev,
//                     'insurance_type':insuranceType
//                 }))
//                 return;
//             }

//             else if (clientVas.service_group_code === service && clientVas.network_code === 'ALL') {
//                 hashmap_clientVas.set(0, clientVas);
//             } 
//             else if (clientVas.network_code === network && clientVas.service_group_code === 'ALL') {
//                 hashmap_clientVas.set(1, clientVas);
//             } 
//             else if (clientVas.network_code === 'ALL' && clientVas.service_group_code === 'ALL') {
//                 hashmap_clientVas.set(2, clientVas);
//             }
//         }
//     }

//     let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);

//     console.log("bean",bean)
//     let insuranceType = "NA";
//     if(bean.insurance_type==='OW'){
//         insuranceType = "Owner";
//     }else if(bean.insurance_type === 'CA'){
//         insuranceType = "Carrier";
//     }
//     setFormValues(prev=>({
//         ...prev,
//         'insurance_type':insuranceType
//     }))
//     return;
// }

// ================== getDocket charge and Insurance================
const setAutoInsuranceAndDockt=async()=>{
    const client = formValues.client.split("|")[1].trim();
    const network = formValues.network.split("|")[1].trim();
    const service = formValues.service.split("|")[1].trim();

    console.log("from master data", masterData.LIST_CLIENTVAS);
    console.log("client network service", client,network,service);

    const serviceGroupCode = getServiceGroupCode(service);
    console.log("service froup code",serviceGroupCode);

    let flag = true;
    const hashMap_ClientVas = new Map();
    let docketAmt = 0;
    let insuranceType = "NA";

    for(const clientVasBean in masterData.LIST_CLIENTVAS){
        const vas =  masterData.LIST_CLIENTVAS[clientVasBean];

        if(client === vas.client_code && network === vas.network_code && serviceGroupCode === vas.service_group_code){

            console.log("before inflag of setInsuranceanddocket",clientVasBean)
            if ("S" === vas.docket_chrg_type) {
                const prefix = getAwbPrefix();
                docketAmt = docketCharge(client,prefix);
                console.log(docketAmt);
            }else{
                docketAmt = vas.docket_amount;
                console.log(vas.docket_amount);
            }

            
            if(clientVasBean.insurance_type?.toUpperCase()==='OW'){
                insuranceType = "Owner";
            }else if(clientVasBean.insurance_type?.toUpperCase() === 'CR'){
                insuranceType = "Carrier";
            }

            flag = false;
            break;

        }else if(client === vas.client_code && network === vas.network_code && 'All' === vas.service_group_code){
            hashMap_ClientVas.set(0,vas);
        }else if(client === vas.client_code && 'All' === vas.network_code && serviceGroupCode === vas.service_group_code){
            hashMap_ClientVas.set(1,vas);
        }if(client === vas.client_code && 'All' === vas.network_code && 'All' === vas.service_group_code){
            hashMap_ClientVas.set(2,vas);
        }
    }

    if(flag){
        let bean;

        if(hashMap_ClientVas.has(0)){
            bean = hashMap_ClientVas.get(0);
        }else if(hashMap_ClientVas.has(1)){
            bean = hashMap_ClientVas.get(1);
        }else if(hashMap_ClientVas.has(2)){
            bean = hashMap_ClientVas.get(2);
        }

        console.log("inflag of setInsuranceanddocket",bean)
        if(!bean){
            console.log("returning not found docket bean")
            return;
        }

        if ("S" === bean.docket_chrg_type) {
            const prefix = getAwbPrefix();
            docketAmt = docketCharge(client,prefix);
            console.log(docketAmt);
        }else{
            docketAmt = bean.docket_amount;
            console.log(bean.docket_amount);
        }

        if(bean.insurance_type?.toUpperCase()==='OW'){
            insuranceType = "Owner";
        }else if(bean.insurance_type?.toUpperCase() === 'CR'){
            insuranceType = "Carrier";
        }
        
    }

    setFormValues(prev=>({
        ...prev,
        'insurance_type':insuranceType,
        'docketCharge':docketAmt
    }))
}

const calculateInsuranceAmount=()=>{

    let client = formValues.client?.split("|")[1]?.trim();
    let network = formValues.network?.split("|")[1]?.trim();
    let service = formValues.service?.split("|")[1]?.trim();
    let insuranceValue = Number(formValues.insValue||0);
    let hashmap_clientVas = new Map();

    console.log("client network service", client,network,service);

    const serviceGroupCode = getServiceGroupCode(service);
    console.log("service froup code",serviceGroupCode);

    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === client){
            console.log("client",client);
            if (clientVas.service_group_code === serviceGroupCode && clientVas.network_code === network) {

                if(formValues.insurance_type === 'Owner'){
                    let insAmt = (insuranceValue * bean.owner_insur_percent)/100;
                    setFormValues(prev=>({
                        ...prev,
                        'insRate':bean.owner_insur_percent,
                        'insAmount':insAmt > bean.owner_insur_fixed? insAmt.toFixed(2) : bean.owner_insur_fixed
                    }))
                    return;
                }else if(formValues.insurance_type==='Carrier'){
                    let insAmt = (insuranceValue * bean.carrier_insur_percent)/100;
                    setFormValues(prev=>({
                        ...prev,
                        'insRate':bean.carrier_insur_percent,
                        'insAmount':insAmt > bean.carrier_insur_fixed? insAmt.toFixed(2) : bean.carrier_insur_fixed
                    }))
                    return;
                }
            }

            else if (clientVas.service_group_code === serviceGroupCode && clientVas.network_code === 'All') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'All' && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);

    console.log("bean",bean)
    if(formValues.insurance_type === 'Owner'){
        let insAmt = (insuranceValue * bean.owner_insur_percent)/100;
        setFormValues(prev=>({
            ...prev,
            'insRate':bean.owner_insur_percent,
            'insAmount':insAmt > bean.owner_insur_fixed? insAmt.toFixed(2) : bean.owner_insur_fixed
        }))
        return;
    }else if(formValues.insurance_type==='Carrier'){
        let insAmt = (insuranceValue * bean.carrier_insur_percent)/100;
        setFormValues(prev=>({
            ...prev,
            'insRate':bean.carrier_insur_percent,
            'insAmount':insAmt > bean.carrier_insur_fixed? insAmt.toFixed(2) : bean.carrier_insur_fixed
        }))
        return;
    }
    return;
}


const checkClientRateFormatForFriegth=async()=>{
    const client = formValues.client.split("|")[1].trim();
        const network = formValues.network.split("|")[1].trim();
        const service = formValues.service.split("|")[1].trim();
        const destPincode = formValues.destPincode;

        const zoneCode = formValues.lbZone||"";
        const destCity = formValues.destCityCode||"";

        const rateFormate = getRateFormatViaClientCode(client);
        const serviceGroupCode = getServiceGroupCode(service);

        
        console.log("client network service zoneCode", client,network,service,serviceGroupCode,zoneCode,destCity);
        if(rateFormate === "B" || rateFormate === ""){
            
            setList_clientRate([]);
            setList_loadRateForAutoCalculation([]);
            const response = await loadRateFromDb(client,network,serviceGroupCode,zoneCode,destCity);
            console.log(response)
            if (response?.length > 0) {

                setList_clientRate(client)

                console.log(list_client);
                setList_loadRateForAutoCalculation(prev=>[
                    ...prev,
                    ...response
                ]);
            }
        }
        else if(rateFormate === "K"){
            
            setList_clientRate([]);
            setList_loadRateForAutoCalculation([]);
            const response = await loadRatesFromDBForLogistic(client,network,serviceGroupCode);
            console.log(response)
            if (response?.length > 0) {

                setList_clientRate(client)

                console.log(list_client);
                setList_loadRateForAutoCalculation(prev=>[
                    ...prev,
                    ...response
                ]);
            }
        }

        setFormValues(prev=>({
            ...prev,
            'rate_format':rateFormate
        }))
        console.log("rateformte logistic", rateFormate," from network");
}


const calculateFriegthAmtFromDb=()=>{

    const SZoneTypeFlag = list_loadRateForAutoCalculation.some(
        item=> item.zone_type === 'S'
    )
    let rateForCalculation = [];
    if(SZoneTypeFlag){
        rateForCalculation = list_loadRateForAutoCalculation.filter(
            item=> item.zone_type === 'S'
        )
        setFormValues(prev=>({
            ...prev,
            'lbZone':formValues.destCityCode
        }))
    }else{
        rateForCalculation = list_loadRateForAutoCalculation.filter(
            item=> item.zone_type === 'Z'
        )
    }


    if(rateForCalculation.length>0){

        // const billWeigth = Number(formValues.billingWt);
        const actual = Number(formValues.actualWt);
        const volume = Number(formValues.volumneWt);

        let calculateBillwt = actual > volume ? formValues.actualWt : formValues.volumneWt;
        setFormValues(prev=>({
            ...prev,
            'billingWt':calculateBillwt
        }))

        let billWeigth = Number(calculateBillwt)
        
        let isKgAvailable = false;
        let isAddAvailable = true;
        let B_nearest = 0, E_nearest = 0, K_nearest = 0, E_addLimt = 0, B_zoneAmount = 0, E_zoneAmount = 0,
                K_zoneAmount = 0, total = 0;
        let B_rateType = "", E_rateType = "", K_rateType = "", zoneType = null, zone_code = null;
        let B_slno = 0, E_slno = 0, K_slno = 0;
        let clientCode = formValues.client.split('|')[1].trim();
        const rateType = getRateTypeViaClientCode(clientCode);
        console.log("from rateCalculation",billWeigth);

        for(const rateBean in rateForCalculation){
            const rate = rateForCalculation[rateBean];

            if(rate.rate_type === 'E'){
                if(rate.add_limit>=billWeigth){
                    isKgAvailable = false;
                    break;
                }else{
                    isKgAvailable = true;
                    break;
                }
            }else if(rate.rate_type === 'K'){
                isKgAvailable = true;
                break;
            }
        }

        if(isKgAvailable){
            for(const rateBean in rateForCalculation){
                const rate = rateForCalculation[rateBean];
                if(rate.rate_type === 'K'){
                    if(rate.slab>=billWeigth){
                        K_nearest = rate.slab;
                        K_zoneAmount = rate.rate;

                        K_slno = rate.sno;
                        K_rateType = rate.rate_type;
                        setFormValues(prev=>({
                            ...prev,
                            WEIGHT_SLAB:rate.slab,
                            WEIGHT_TYPE:'K'
                        }))
                        isKgAvailable = true;
                        break;
                    }else{
                        K_nearest = rate.slab;

                        K_zoneAmount = rate.rate;

                        K_slno = rate.sno;
                        K_rateType = rate.rate_type;
                        setFormValues(prev=>({
                            ...prev,
                            WEIGHT_SLAB:rate.slab,
                            WEIGHT_TYPE:'K'
                        }))
                        isKgAvailable = true;
                    }
                }
            }

        }else{
            for(const rateBean in rateForCalculation){
                const rate = rateForCalculation[rateBean];

                if(rate.rate_type==='B'){

                    B_nearest = rate.slab
                    B_zoneAmount = rate.rate;

                    setFormValues(prev=>({
                            ...prev,
                            WEIGHT_SLAB:rate.slab,
                            WEIGHT_TYPE:'B'
                        }))
                    B_slno = rate.sno
                    B_rateType = rate.rate_type
                    

                    if (B_nearest >= billWeigth) {
                        isAddAvailable = false;
                        break;
                    }
                }
            }

            if(isAddAvailable){
                for(const rateBean in rateForCalculation){
                    const rate = rateForCalculation[rateBean];

                    if(rate.rate_type === 'E'){
                        E_zoneAmount = rate.rate

                        setFormValues(prev=>({
                            ...prev,
                            WEIGHT_SLAB:rate.add_limit,
                            WEIGHT_TYPE:'E'
                        }))
                        E_addLimt = rate.add_limit
                        E_slno = rate.sno
                        E_rateType = rate.rate_type
                        E_nearest = rate.slab
                        break;
                    }
                }
            }
        }

        total = basicRateFormula(B_slno,B_zoneAmount) + addRateFormula(E_slno,E_zoneAmount,B_nearest,E_nearest,billWeigth) + kgRateFormula(K_slno,K_zoneAmount,rateType,billWeigth,Number(formValues.pcs));
        console.log("total not new friegth amt,",total);
        setFormValues(prev=>({
                ...prev,
                'friegthAmt':total,
                'amount':total
            }))
    }else{
        console.log("is empty");
        console.log(rateForCalculation);
    }
}

const calculateFriegthAmountFromLogistic=()=>{
    let originZone = '', destinationZone = '';
    let originZoneFound = false, destinationZoneFound = false;
    let originPincode = formValues.originPincode;
    let destinationPincode =  formValues.destPincode;

    // const billWeigth = Number(formValues.billingWt);
    const actual = Number(formValues.actualWt);
    const volume = Number(formValues.volumneWt);
    const clientCode = formValues.client.split("|")[1].trim();
    const rateType = getRateTypeViaClientCode(clientCode);  
    let calculatebillWeigth = actual > volume ? formValues.actualWt : formValues.volumneWt;
    const pcs = Number(formValues.pcs||0);
    setFormValues(prev=>({
        ...prev,
        'billingWt':calculatebillWeigth
    }))
    let billWeigth = Number(calculatebillWeigth)
    for(const pincodeIndex in masterData.LIST_PINCODE){

        const pincodeBean = masterData.LIST_PINCODE[pincodeIndex];

        if(originPincode === pincodeBean.pin_code){
            originZone = pincodeBean.zon_code_kg;
            originZoneFound = true;
        }

        if(destinationPincode === pincodeBean.pin_code){
            destinationZone = pincodeBean.zon_code_kg;
            destinationZoneFound = true;
        }

        if(originZoneFound && destinationZoneFound){
            break;
        }
    }
    console.log("origin destination ",originZone,destinationZone);

    if(!originZone || !destinationZone){
        setFormValues(prev=>({
            ...prev,
            'friegthAmt':0,
            'amount':0
        }))
        return;
    }

    for(const logisticRateIndex in list_loadRateForAutoCalculation){
        const logisticRate = list_loadRateForAutoCalculation[logisticRateIndex];

        if(originZone === logisticRate.origin_zone && destinationZone === logisticRate.destination_zone){
            console.log(logisticRate);
            let wtLimit = 0;
            for(const clientIndex in masterData.LIST_CLIENT){
                const client = masterData.LIST_CLIENT[clientIndex];

                if(client.client_code === clientCode){
                    wtLimit = client.logistic_wt_limit;
                    break;
                }
            }

            let amt = 0;
            if (rateType == '') {
                amt = Math.ceil(billWeigth <= wtLimit ? wtLimit : billWeigth) * logisticRate.rate;
            } else if (rateType === "KG") {
                amt = Math.ceil(billWeigth <= wtLimit ? wtLimit : billWeigth) * logisticRate.rate;
            } else if (rateType === "PCS") {
                amt = pcs * logisticRate.rate;
            }
            setFormValues(prev=>({
                ...prev,
                'friegthAmt':amt,
                'amount':amt
            }))
            console.log("logistic amt wt bill logisticRate.rate;",amt,wtLimit,billWeigth,logisticRate.rate)
            break;
        }
    }
}

const calculateCodAmount=()=>{
    let client = formValues.client?.split("|")[1]?.trim();
    let network = formValues.network?.split("|")[1]?.trim();
    let service = formValues.service?.split("|")[1]?.trim();
    let codValue = Number(formValues.codValue||0);
    let hashmap_clientVas = new Map(); 

    console.log("client network service", client,network,service);

    const serviceGroupCode = getServiceGroupCode(service);
    console.log("service froup code",serviceGroupCode);

    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === client){
            if(clientVas.service_group_code === serviceGroupCode && clientVas.network_code === network){
                let codAmt = (codValue * clientVas.cod_percent)/100;
                codAmt  = codAmt > clientVas.cod_fixed ? codAmt.toFixed(2) : clientVas.cod_fixed;
                setFormValues(prev=>({
                    ...prev,
                    'codAmount': codAmt
                }))

                return codAmt;
            }
            else if (clientVas.service_group_code === serviceGroupCode && clientVas.network_code === 'All') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'All' && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }

    let bean = hashmap_clientVas.get(0)||hashmap_clientVas.get(1)||hashmap_clientVas.get(2);
    console.log("cod bean",bean);
    if(!bean){
        console.log("cod bean not found");
        return;
    }

    let codAmt = (codValue * bean.cod_percent)/100;
    codAmt = codAmt > bean.cod_fixed ? codAmt.toFixed(2) : bean.cod_fixed;
    setFormValues(prev=>({
        ...prev,
        'codAmount': codAmt
    }))
    return codAmt;
}

const calculateFodAmount=()=>{
    let client = formValues.client?.split("|")[1]?.trim();
    let network = formValues.network?.split("|")[1]?.trim();
    let service = formValues.service?.split("|")[1]?.trim();
    let fodValue = Number(formValues.fodValue||0);
    let hashmap_clientVas = new Map(); 

    console.log("client network service", client,network,service);

    const serviceGroupCode = getServiceGroupCode(service);
    console.log("service froup code",serviceGroupCode);

    for(let clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === client){
            if(clientVas.service_group_code === serviceGroupCode && clientVas.network_code === network){
                let fodAmt = (fodValue * clientVas.fod_percent)/100;
                fodAmt = fodAmt > clientVas.fod_fixed ? fodAmt.toFixed(2) : clientVas.fod_fixed
                setFormValues(prev=>({
                    ...prev,
                    'fodAmount': fodAmt
                }))

                return fodAmt;
            }
            else if (clientVas.service_group_code === serviceGroupCode && clientVas.network_code === 'All') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'All' && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }

    let bean = hashmap_clientVas.get(0)||hashmap_clientVas.get(1)||hashmap_clientVas.get(2);
    if(!bean){
        console.log("fod bean not found");
        return 0;
    }

    let fodAmt = (fodValue * bean.fod_percent)/100;
    fodAmt = fodAmt > bean.fod_fixed ? fodAmt.toFixed(2) : bean.fod_fixed
    console.log(fodAmt,"fodAmt from it method");
    setFormValues(prev=>({
        ...prev,
        'fodAmount': fodAmt
    }))
    return fodAmt;
}


const calculateFuel =(friegthAmt,subVasTotal)=>{
    let client = formValues.client?.split("|")[1]?.trim();
    let network = formValues.network?.split("|")[1]?.trim();
    let service = formValues.service?.split("|")[1]?.trim();
    friegthAmt = Number(friegthAmt);
    subVasTotal = Number(subVasTotal);
    let hashmap_clientVas = new Map(); 
    console.log(subVasTotal,friegthAmt ,Number(formValues.fodAmount||0),"subVasTotal friegthAmt Number(formValues.fodAmount||0)");
    console.log("client network service", client,network,service);

    const serviceGroupCode = getServiceGroupCode(service);
    console.log("service froup code",serviceGroupCode);

    for(const clientVas of masterData.LIST_CLIENTVAS){
        if(clientVas.client_code === client){

            if(clientVas.service_group_code === serviceGroupCode && clientVas.network_code === network){
                let fuelOnVas = 0;
                if(clientVas.fuel_on_insurance === 'T' && clientVas.fuel_on_vas === 'T'){
                    fuelOnVas = ((friegthAmt + subVasTotal)*clientVas.fuel_rate)/100;
                }else if(clientVas.fuel_on_insurance === 'F'){
                    fuelOnVas = ((friegthAmt + Number(formValues.insAmount))*clientVas.fuel_rate)/100;
                }else if(clientVas.fuel_on_vas === 'T'){
                    fuelOnVas = ((friegthAmt + subVasTotal)*clientVas.fuel_rate)/100;
                }else{
                    fuelOnVas = (friegthAmt*clientVas.fuel_rate)/100;
                }
                console.log("fuel amt",fuelOnVas)

                setFormValues(prev=>({
                    ...prev,
                    'fuelAmt':fuelOnVas.toFixed(2),
                    'fuelRate':clientVas.fuel_rate
                }))
                return fuelOnVas.toFixed(2);
            }
            else if (clientVas.service_group_code === serviceGroupCode && clientVas.network_code === 'All') {
                hashmap_clientVas.set(0, clientVas);
            } 
            else if (clientVas.network_code === network && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(1, clientVas);
            } 
            else if (clientVas.network_code === 'All' && clientVas.service_group_code === 'All') {
                hashmap_clientVas.set(2, clientVas);
            }
        }
    }

    let bean = hashmap_clientVas.get(0) || hashmap_clientVas.get(1) || hashmap_clientVas.get(2);
    console.log("fuel bean",bean);
    if(!bean){
        console.log("fuel bean not found");
        return 0;
    }

    let fuelOnVas = 0;
    if(bean.fuel_on_insurance === 'T' && bean.fuel_on_vas === 'T'){
        fuelOnVas = ((friegthAmt + subVasTotal)*bean.fuel_rate)/100;
    }else if(bean.fuel_on_insurance === 'F'){
        fuelOnVas = ((friegthAmt + Number(formValues.insAmount))*bean.fuel_rate)/100;
    }else if(bean.fuel_on_vas === 'T'){
        fuelOnVas = ((friegthAmt + subVasTotal)*bean.fuel_rate)/100;
    }else{
        fuelOnVas = (friegthAmt*bean.fuel_rate)/100;
    }
    console.log("fuel amt",fuelOnVas)

    setFormValues(prev=>({
        ...prev,
        'fuelAmt':fuelOnVas.toFixed(2),
        'fuelRate':bean.fuel_rate
    }))

    return fuelOnVas.toFixed(2)
}

const calculateGST=async(friegthAmt,subVasTotal,fuelAmt)=>{
    let client = formValues.client.split("|")?.[1]?.trim();
    let clientBranch = '';
    let branchCodeFromDB = '';
    let clientStateCode = '';
    let taxStatus = true;
    for(let clientBean of masterData.LIST_CLIENT){
        if(client === clientBean.client_code){
            clientBranch = clientBean.branch_code;
            if(clientBean.tax_status === 'Y'){
                taxStatus = true;
            }else{
                taxStatus = false;
            }
            break;
        }
    }

    let branchDetail = await getBranchFromDb(clientBranch);

    for(const branchBean of branchDetail){
        if(clientBranch === branchBean.brn_code){
            branchCodeFromDB = branchBean.brn_state_code;
            break;
        }
    }
    console.log("get branch branchCodeFromDB" ,branchDetail,branchCodeFromDB)

    let clientAddress = await getClientAddressFromDb(client);
    

    for(const address of clientAddress){
        if(client === address.client_code){
            clientStateCode = address.state_code;
            break;
        }
    }
    console.log("client  state",clientAddress,);
    console.log("client  state",clientStateCode,);

    if(!clientStateCode){
        clientStateCode = 'NA';
    }


    let origin_destination_state = branchCodeFromDB + " | " + clientStateCode;
    console.log(origin_destination_state,"origin_destination_state")

    if(taxStatus){
        let taxObject = await getTaxSeriesFromDb();
        if(taxObject.length===0)return alert("Tax data detail not found");
    
        let cgst = 0;
        let sgst = 0;
        let igst = 0;
    
        let cgstTax = taxObject[0].tax_rate;
        let sgstTax = taxObject[0].edu_cess_rate;
        let igstTax = taxObject[0].higher_cess_rate;

        let taxableAmount = friegthAmt + subVasTotal + Number(fuelAmt||0);
        console.log(friegthAmt , subVasTotal , fuelAmt)
        console.log(taxableAmount,"taxableamount");

        if(branchCodeFromDB === clientStateCode){
            cgst = (taxableAmount * cgstTax)/100;
            sgst = (taxableAmount * sgstTax)/100;
        }else{
            igst = (taxableAmount * igstTax)/100;
        }
    
        let totalTax = cgst + sgst + igst;
        let finalAmount = taxableAmount + totalTax;
        console.log(finalAmount+"finalAMt");
        console.log(totalTax+"totalTax");
        console.log(taxableAmount+"taxableAmt")
        setFormValues(prev=>({
            ...prev,
            'taxName1':taxObject[0].tax_name,
            'taxRate1':cgst,
            'taxName2':taxObject[0].edu_name,
            'taxRate2':sgstTax,
            'taxName3':taxObject[0].h_edu_name,
            'taxRate3':igstTax,
            'service_tax':cgst,
            'edu_cess':sgst,
            'h_edu_Cess':igst,
            'Total':finalAmount.toFixed(2),
            'totalGst':totalTax.toFixed(2)
        }))
    }else{
        setFormValues(prev=>({
            ...prev,
            'taxName1':'CGST',
            'taxRate1':0,
            'taxName2':'SGST',
            'taxRate2':0,
            'taxName3':'IGST',
            'taxRate3':0,
            'service_tax':0,
            'edu_cess':0,
            'h_edu_Cess':0,
            'totalGst':0
        }))
    }

}

  return {formValues,setDate,loading,setLoading,setFormValues,originPin,pincodeList,filteredOriginPincodes,setFilteredOriginPincodes,filteredDestPincodes,setFilteredDestPincodes,handleBlurPincode,handleInputChange,client,setClient,clientOption,service,network,activeOriginIndex,setActiveOriginIndex,selectOriginPincode,selectDestPincode,setActiveDestIndex,activeDestIndex,handleDecimalInputChange,handleNumberInputChange,checkValidation,resetAction,awbBlurHandle,betterLoggerFunction,activeConsigneeIndex,setActiveConsigneeIndex,filterConsignee,selectConsignee,setFilterConsignee,weigthDimension,setWeigthDimension,enterDimensionMMB_LIVE,enterDimensionMMB,handleWeigthDecimalInputChange,dimensionList,setDimensionList,showDimensionWeigthModal,setShowDimensionWeigthModal,disableAwb,handleWeigthDimenstionFocus,isModifyingDisable,isSaveDisable,removeEnteredDimension,setFuelAmount,showEWayBillModal,setShowEWayBillModal,eWayBillList,setEWayBillLIst,enterEWayBillNumber,ewaybillObj,removeEnteredEWayBill,handleEWayBillFocus,handleBlurOfVolumeWt,printDocket,handleEnterAsTab,dateRef}
}

export default FastBookingController
